/* ============================================================
   Himedi Checkup Flow — shared interactions + state (theme build)
   MVP 7.0 modular model. State persists across pages via localStorage.
   Mock only: booking calendar has no real availability (wired at port).
   ============================================================ */
(function(){
  "use strict";
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  /* ---- single source of truth for prices/contents (whole-upgrade price only) ----
     variant = hidden Shopify product variant (MVP 7.0 test products, tag: himedi-v7-test). */
  var BASES = {
    baseline: { name:'Baseline checkup', price:299,  variant:56711215382694, blurb:'Your comprehensive foundation — 24 test categories.' },
    wbmri:    { name:'Whole Body MRI',   price:1700, variant:56900675829926, blurb:'Head-to-pelvis MRI. No radiation, no contrast dye.' }
  };
  /* The WBMRI product carries a second, combined variant — "Whole Body MRI + Checkup"
     at $1,999 — which is the MRI and the baseline checkup sold as ONE line. If the
     booking event is bound to that variant, EAB adds the whole $1,999 in a single line
     and we must not add the $299 baseline on top of it. Handled in buildItems.
     Prices updated 2026-09-10 (MRI $1,500 → $1,700, MRI + Checkup $1,799 → $1,999) to
     match the product page — this file's BASES table is the single source of truth for
     the on-page running total; the Theme Editor's "WBMRI price" text field is display-only
     and does not feed this calculation, which is why editing it alone did not update the
     sticky footer total. */
  var WBMRI_COMBO_VARIANT = 56900675928230;
  /* ---- WBMRI PROMO DATE GATE (2026-09-28) --------------------------
     CONFIG BLOCK. Today the WBMRI product carries its own "Booking window"
     Standard/Promo option (confirmed live via GraphQL product read, 2026-09-28: 4
     variants -- "Whole Body MRI / Standard" 56900675829926, "Whole Body MRI + Checkup
     / Standard" 56900675928230 (= WBMRI_COMBO_VARIANT above), "Whole Body MRI / Promo"
     57248354468006, "Whole Body MRI + Checkup / Promo" 57248354500774) but NOTHING in
     this file ever chose the Promo twin: desiredVariants()'s wbmri branch always uses
     BASES.wbmri.variant / WBMRI_COMBO_VARIANT directly, so a WBMRI booking gets the
     Standard variant on every appointment date. The live "WB MRI BOGO 20%" discount
     (gid://shopify/DiscountAutomaticNode/2386001756326) is scoped by PRODUCT, not by
     variant, so this has never mattered before -- it discounts a WBMRI order on ANY
     appointment date today, with no date gate at all (confirmed by reading this file
     end to end; no isPromoWindowProps call touches the wbmri path anywhere below).
     the ended promo's WBMRI discount (see the 2026-09-28 discount script) is instead
     scoped to the two Promo variant ids below, mirroring COMBO_VARIANTS' std/sep
     pattern exactly, so the appointment-date gate has to exist here for the first time. */
  var WBMRI_STD_TO_PROMO = {};
  WBMRI_STD_TO_PROMO[String(56900675829926)] = 57248354468006; // WBMRI alone: Standard -> Promo
  WBMRI_STD_TO_PROMO[String(56900675928230)] = 57248354500774; // WBMRI + Checkup combo: Standard -> Promo
  /* 2026-10-13: the reverse map. Without it the reconcile, the base-line list and buildItems() did not
     know a WBMRI Promo line IS the MRI the build asked for, so every ended promo WBMRI booking got a
     second, undated Standard MRI added next to it ($3,400 for one MRI, and the pair discount never
     applied because only one line was Promo). Reported by Jenn from a customer, reproduced live. */
  var WBMRI_PROMO_TO_STD = {};
  Object.keys(WBMRI_STD_TO_PROMO).forEach(function(std){ WBMRI_PROMO_TO_STD[String(WBMRI_STD_TO_PROMO[std])] = Number(std); });

  /* ---- TWO GO-LIVE FLAGS (2026-09-28, coordinator follow-up) ----------------------
     Both mirrored byte-for-byte in the 2026-09-28 discount script under the SAME
     names -- preflight.py's flag-agreement checks parse both files as plain text and
     compare, so the two must always read `true`/`false`/`True`/`False` here and in
     Python together, or the deploy is refused before it touches Shopify.

     WBMRI_PROMO_GATE (default true). We could not confirm before Wednesday that the two
     WBMRI Promo variants (57248354468006 / 57248354500774) are attached to the WBMRI
     Servicify booking event -- if they are not, EAB may refuse or silently drop a
     booking made against them. true = the WBMRI Standard->Promo swap at add time and
     the stale-promo downgrade both run, and the 2026-09-28 discount script's 20% discount is
     scoped to the two Promo variant ids (this build's default plan). false = WBMRI is
     left running EXACTLY like today's live code -- no swap, no downgrade -- and
     the 2026-09-28 discount script instead scopes the 20% discount to the whole WBMRI PRODUCT,
     mirroring the live "WB MRI BOGO 20%" discount (2386001756326): any appointment
     date qualifies, same as today, no date gate at all for WBMRI.

     INCLUDE_PLAIN_BASELINE_PROMO (default false, matches the 2026-09-28 discount script's
     INCLUDE_PLAIN_BASELINE). Will's ended promo terms are "Baseline + Focus Area: 50%
     off"; plain Baseline (no focus area) was never meant to qualify. false = a plain
     Baseline booking is NEVER rewritten to its Promo twin, at add time or by the
     stale-promo reconcile, in either window -- it always stays on Standard. true =
     plain Baseline is treated exactly like every other Checkup combination (rewritten
     to Promo when its date is in the active window, same as Baseline+Heart etc). */
  var WBMRI_PROMO_GATE = true; // 2026-09-30 20:10Z: WB-MRI Promo variants are on the active calendar 128502 with Standard (every real WB-MRI order: _Event # 128502)
  var INCLUDE_PLAIN_BASELINE_PROMO = true; // 2026-11-02: only so the rewind also moves a held plain Baseline / Promo line to Standard. The window is closed, so nothing can be granted.

  /* ---- THE CHECKUP COMBINATION TABLE (2026-08-26) -------------------------
     A "checkup" is one Baseline plus any focus areas. Shopify's discount engine
     can only condition on product / variant / collection -- it cannot read a line
     property -- so a checkup that lives across several cart lines is something no
     native discount can compare. Selling each combination as ONE variant of the
     `Checkup` product makes a checkup a thing Shopify can see, and a BOGO becomes
     an ordinary Buy-X-Get-Y over those variants.
     Each combination exists twice at the SAME price: Standard and September 2026.
     The September twin is what the discount is scoped to, which is how an
     appointment-month promo is expressed without the discount engine ever knowing
     what a date is. All 16 are attached to EAB event 130604 "Main Booking Request".
     Keys are the upgrade ids, sorted and joined -- see comboKey(). */
  var COMBO_VARIANTS = {
    'base': { std:57177214451878, sep:57189184766118, price:299 },
    'heart': { std:57189184798886, sep:57189184831654, price:669 },
    'cancer': { std:57189184864422, sep:57189184897190, price:774 },
    'brain': { std:57189184929958, sep:57189184962726, price:1179 },
    'cancer+heart': { std:57189184995494, sep:57189185028262, price:1144 },
    'brain+heart': { std:57189185061030, sep:57189185093798, price:1549 },
    'brain+cancer': { std:57189185126566, sep:57189185159334, price:1654 },
    'brain+cancer+heart': { std:57189185192102, sep:57189185224870, price:2024 }
  };

  function comboKey(){
    var ks=[];
    ['brain','cancer','heart'].forEach(function(k){
      if(state.upgrades[k] && upgradeAvailable(k)) ks.push(k);
    });
    ks.sort();
    return ks.join('+') || 'base';
  }
  /* september=true returns the September twin of the same combination. */
  function comboVariant(september){
    var e = COMBO_VARIANTS[comboKey()];
    if(!e) return null;
    return september ? e.sep : e.std;
  }
  /* Standard id -> September id, for the add-to-cart rewrite below. */
  var STD_TO_SEP = (function(){
    var m={};
    Object.keys(COMBO_VARIANTS).forEach(function(k){
      m[String(COMBO_VARIANTS[k].std)] = COMBO_VARIANTS[k].sep;
    });
    return m;
  })();
  var ALL_COMBO_VARIANTS = (function(){
    var a=[];
    Object.keys(COMBO_VARIANTS).forEach(function(k){
      a.push(Number(COMBO_VARIANTS[k].std), Number(COMBO_VARIANTS[k].sep));
    });
    return a;
  })();
  /* ---- PROMO BOOKING WINDOW -------------------------------------------------
     CONFIG BLOCK -- ended promo swap (2026-09-28, himedi/runs, 2026-09-28 promo run).
     Every number/date/string this swap depends on lives in this one block so a late
     partner-review edit (Wed 9/30) is one line here. Extended 2026-08-28: the promo
     ran September only, then SEPTEMBER-DECEMBER 2026. This is Phase 2: the code now
     carries BOTH the OLD window (kept byte-for-byte in behaviour, for any read before
     the switch) and the ended promo's NEW window (Dec 1 2026 - Apr 30 2027), picked by the
     CURRENT TIME, not by an edit made at midnight -- nothing runs at midnight; this
     file already knows both states and always did going forward.

     EAB writes human date strings and there is no date type to range-check. Measured
     against 30 real orders, exactly two shapes occur:
         Date         "September 3, 2026"            "October 7, 2026"
         _Start Date  "Thursday, September 3rd 2026" "Wednesday, October 7th 2026"
     A missing or unreadable value is NOT in the window: withhold, never grant.

     PREVIEW OVERRIDE: ?promo_at=<ISO> changes what "now" is FOR THIS DECISION ONLY
     (old-window-vs-new-window), and only when the theme rendering it is not the
     published one (Shopify.theme.role !== 'main') or Theme Editor preview
     (Shopify.designMode) -- so it can never move what a real customer on the live
     theme sees, matching the same override rule used in the promo banner snippet. */
  /* TEST-EXTRACT:isPromoWindow:START */
  var PROMO_SWITCH_AT = '2026-10-01T04:00:00Z';   // midnight US Eastern -- Gabe's choice
  var PROMO_SWITCH_MS = Date.parse(PROMO_SWITCH_AT);
  var OLD_PROMO_MONTHS   = ['September','October','November','December']; // unchanged from today
  var OLD_PROMO_YEAR     = 2026;                                          // unchanged from today
  var NEW_PROMO_START_KEY = 20261201;                  // Dec 1 2026, inclusive
  var NEW_PROMO_END_KEY   = 0;                         // 2026-11-02: promo over. End before start, so no date is in the window; the rewind moves held lines to Standard
  var PROMO_MONTH_NAMES = ['January','February','March','April','May','June','July',
    'August','September','October','November','December'];
  var PROMO_MONTH_NUM = (function(){
    var m = {};
    PROMO_MONTH_NAMES.forEach(function(name, i){ m[name] = i + 1; });
    return m;
  })();
  var PROMO_DATE_RE = new RegExp(
    '(' + PROMO_MONTH_NAMES.join('|') + ')' +   // month name
    '\\s+(\\d{1,2})(?:st|nd|rd|th)?' +           // day, with or without ordinal suffix
    ',?\\s*' +                                   // optional comma
    '(\\d{4})'                                   // year
  );
  function promoPreviewAllowed(){
    try{
      return !!(window.Shopify && (
        (window.Shopify.theme && window.Shopify.theme.role !== 'main') ||
        window.Shopify.designMode
      ));
    }catch(e){ return false; }
  }
  function promoNowMs(){
    try{
      if(promoPreviewAllowed()){
        var m = /[?&]promo_at=([^&]+)/.exec(window.location.search);
        if(m){
          var t = Date.parse(decodeURIComponent(m[1]));
          if(!isNaN(t)) return t;
        }
      }
    }catch(e){}
    return Date.now();
  }
  function isPromoWindowProps(props){
    if(!props) return false;
    var v = String(props['Date'] || props['_Start Date'] || '');
    var m = PROMO_DATE_RE.exec(v);
    if(!m) return false;
    var monthNum = PROMO_MONTH_NUM[m[1]];
    var day = Number(m[2]);
    var year = Number(m[3]);
    if(!monthNum || !day || !year) return false;
    if(promoNowMs() < PROMO_SWITCH_MS){
      // OLD window: identical to today's live behaviour -- month + year only, no day check.
      return OLD_PROMO_MONTHS.indexOf(m[1]) !== -1 && year === OLD_PROMO_YEAR;
    }
    // NEW (ended promo) window: Dec 1 2026 - Apr 30 2027 inclusive, day-level comparison.
    var key = year * 10000 + monthNum * 100 + day;
    return key >= NEW_PROMO_START_KEY && key <= NEW_PROMO_END_KEY;
  }
  /* TEST-EXTRACT:isPromoWindow:END */
  /* Kept so nothing that still calls the old name silently returns undefined. */
  var isSeptemberProps = isPromoWindowProps;
  var BASELINE = BASES.baseline; // back-compat for the base-body copy
  var UPGRADES = {
    heart:  { name:'Heart',  price:370,  variant:56711215415462, base:'baseline', tests:['Coronary Artery Calcification CT','Echocardiography','ApoB + Lipoprotein(a)','Arteriosclerosis'] },
    brain:  { name:'Brain',  price:880, variant:56711215448230, base:'baseline', tests:['Brain MRI','Cerebrovascular MRA','Alzheimer’s & Dementia Risk','Carotid Artery Ultrasound'] },
    cancer: { name:'Cancer', price:475,  variant:56711215480998, base:'baseline', tests:['M2-PK','Chest CT','Gastroscopy under sedation','Breast Ultrasound'] },
    checkup:{ name:'Baseline Checkup', price:299, variant:56711215382694, base:'wbmri', tests:['The full Baseline checkup — all 24 test categories'] }
  };
  // NOTE: add-on prices are PLACEHOLDERS — final prices TBD by Gabe.
  /* Add-ons differ by base. The Baseline checkup and the Whole Body MRI are bought
     from different clinics at different rates, and two add-ons are not offered on the
     MRI route at all, so each base has its own catalogue and its own products. The
     WBMRI DNA test is a different test under a different name — Whole Genome Sequence
     — which is why it is a separate product rather than a second variant: the product
     title is what the customer sees in the cart, at checkout and in the order email. */
  var ADDONS_BY_BASE = {
    baseline: {
      amh:        { name:'AMH', cat:'Women’s', price:89,  variant:56711215513766 },
      masto:      { name:'Masto-check', cat:'Women’s', price:119, variant:56711215546534 },
      roma:       { name:'ROMA', cat:'Women’s', price:89, variant:56711215579302 },
      dna:        { name:'DNA Cancer Test (10 Major Cancers)', cat:'Cancer', price:299, variant:56711215612070 },
      /* 2026-10-02 (Gabe): Breast Ultrasound and Colonoscopy are no longer Baseline
         add-ons; M2-PK replaced Colonoscopy in the Cancer focus area and is sold here too.
         includedIn:'cancer' lets isCovered() lock the row so it is never sold twice. */
      m2pk:       { name:'M2-PK', cat:'Cancer', price:100, variant:57555614957734, includedIn:'cancer' },
      gastro_sed: { name:'Gastroscopy under sedation', cat:'Cancer', price:165, variant:56711215677606, includedIn:'cancer' },
      allergy:    { name:'Allergy Panel', cat:'Allergy', price:149, variant:56711215743142 },
      microbiome: { name:'Macrogen Gut Microbiome Stool Test', cat:'Digestive', price:189, variant:56711215775910 },
      vitamin:    { name:'Vitamin Panel (D + B12)', cat:'Vitamin', price:59, variant:56711215808678 }
    },
    wbmri: {
      amh:        { name:'AMH', cat:'Women’s', price:90,  variant:56910522908838 },
      /* Deliberately NO includedIn here. The Cancer focus area is bound to base
         'baseline' (see UPGRADES), so it is not selectable on the MRI route and there
         is nothing that could already cover this. Same $140 variant as the checkup
         route — Gabe set one price for both. */
      breast_us:  { name:'Breast Ultrasound', cat:'Women’s', price:140, variant:56937096478886 },
      roma:       { name:'ROMA', cat:'Women’s', price:70,  variant:56910522974374 },
      dna:        { name:'Whole Genome Sequence', cat:'Genetic', price:1080, variant:56910523007142 },
      colon_sed:  { name:'Colonoscopy under sedation', cat:'Cancer', price:260, variant:56910523072678 },
      gastro_sed: { name:'Gastroscopy under sedation', cat:'Cancer', price:140, variant:56910523105446 },
      allergy:    { name:'Allergy Test', cat:'Allergy', price:140, variant:56910523138214 },
      vitamin:    { name:'Vitamin Panel (D + B12)', cat:'Vitamin', price:47, variant:56910523170982 }
      /* Masto-check and Macrogen Gut Microbiome are not offered on the MRI route. */
    }
  };
  // resolved against the CURRENT base every time, so switching base re-prices the page
  function addonsFor(b){ return ADDONS_BY_BASE[b] || ADDONS_BY_BASE.baseline; }
  var ADDONS = addonsFor((function(){ try{ return (JSON.parse(localStorage.getItem('himedi_checkup_v12'))||{}).base; }catch(e){ return 'baseline'; } })());

  /* ---- state ---- */
  var KEY='himedi_checkup_v12';
  function load(){
    var s=null;
    try{ s=JSON.parse(localStorage.getItem(KEY)); }catch(e){}
    if(!s || typeof s!=='object') s={};
    /* Normalise on EVERY load, not just first run. A stored state written by an
       older build — or half-written — can be missing whole keys, and reading
       state.addons[id] on an undefined addons throws a TypeError. That throw is
       caught by commitCheckup's .catch(), so the symptom is a Checkout button
       that appears to do nothing. Defaulting here makes that impossible. */
    return {
      base:     s.base || 'baseline',
      upgrades: (s.upgrades && typeof s.upgrades==='object') ? s.upgrades : {},
      addons:   (s.addons   && typeof s.addons==='object')   ? s.addons   : {},
      date:     s.date || null,
      slot:     s.slot || null,
      fromQuiz: !!s.fromQuiz,
      /* READ-ONLY LEGACY (2026-08-27). committedGroup was the ordinal of the group
         this build committed into, and it was also the label and half the machine
         key. It is no longer any of those and is no longer WRITTEN — see the
         three-fields note at makeGid(). It is still READ, for exactly one reason:
         a state persisted before 2026-08-24 carries it and no committedGid, and the
         fallback at COMMIT_GID reconstructs 'c'+N from it so that customer does not
         stop recognising their own appointment. One save() later it is gone. */
      committedGroup: (typeof s.committedGroup === 'number') ? s.committedGroup : null,
      /* The FULL group key this build committed into, e.g. "g-qkzfhxmpwr". THIS is
         the machine key every match is made on. Added 2026-08-24 — see makeGid(). */
      committedGid: (typeof s.committedGid === 'string' && s.committedGid) ? s.committedGid : null,
      /* The group's sort key — the value of its _cseq line property. Persisted so a
         reload re-adopts the same position instead of minting a later one. A state
         written before 2026-08-27 has none: it is derived from the legacy ordinal
         still embedded in committedGid, which is exactly how canonicaliseLabels()
         ranks such a group, so the pin and the cart agree. */
      committedSeq: (function(){
        if(typeof s.committedSeq === 'string' && s.committedSeq) return s.committedSeq;
        var m = /^c(\d+)(?:-|$)/.exec(String(s.committedGid || ''));
        return m ? m[1] : null;
      })(),
      /* SEALED GROUP (2026-09-18). Set the moment a commit hands the group off —
         mode 'checkout' pressed — and cleared with the pin. While the pinned group
         is sealed no later page load may reconcile into it: the box still shows so a
         customer who taps back from checkout can go again, but the group is done.
         Reproduced live: checkout → back → add an add-on → summary put the add-on
         into Checkup 1 before any second booking, and the second booking then added
         it again under Checkup 2. See pinSealed(). */
      sealedGid: (typeof s.sealedGid === 'string' && s.sealedGid) ? s.sealedGid : null,
      /* buildHash() of the build the sealed group holds, taken at seal time, so a
         later load can tell the customer the cart was NOT changed to match what
         they edited since. */
      committedBuild: (typeof s.committedBuild === 'string' && s.committedBuild) ? s.committedBuild : null
    };
  }
  function save(s){ try{ localStorage.setItem(KEY, JSON.stringify(s)); }catch(e){} }
  var state=load();

  function money(n){ return '$'+n.toLocaleString('en-US'); }
  // true when the selected focus area already contains this add-on
  function isCovered(k){ var a=ADDONS[k]; return !!(a && a.includedIn && state.upgrades[a.includedIn]); }
  function baseKey(){ return BASES[state.base] ? state.base : 'baseline'; }
  function currentBase(){ return BASES[baseKey()]; }
  // a focus area only counts when it belongs to the selected base
  function upgradeAvailable(k){ return (UPGRADES[k].base || 'baseline') === baseKey(); }

  /* ---- which booking calendar this build needs ----
     Brain contains the brain MRI and Cancer contains the colonoscopy; both have
     tighter clinic availability than the standard morning slot, so each gets its
     own EAB event. Per the availability chart the rule is a simple precedence —
     Brain wins, then Cancer, then Baseline. Heart never changes the calendar.
       Baseline · Baseline+Heart                                  -> baseline
       Baseline+Brain · +Heart+Brain · +Brain+Cancer · all four   -> brain
       Baseline+Cancer · Baseline+Heart+Cancer                    -> cancer
     Whole Body MRI is a different product with its own event, so it takes
     precedence over everything above. */
  function calendarKey(){
    /* Every checkup combination is one product on one calendar now, so the old
       four-way split (baseline / brain / cancer) collapses to a single embed.
       The MRI is still a different product with its own event. */
    if(baseKey()==='wbmri') return 'wbmri';
    return 'checkup';
  }
  function total(){
    var t=currentBase().price;
    Object.keys(UPGRADES).forEach(function(k){ if(state.upgrades[k] && upgradeAvailable(k)) t+=UPGRADES[k].price; });
    Object.keys(ADDONS).forEach(function(k){ if(state.addons[k] && ADDONS[k].price && !isCovered(k)) t+=ADDONS[k].price; });
    return t;
  }

  /* ---- sticky footer total (build + add-ons pages) ---- */
  function paintFooter(){
    var tv=$('#footTotal'); if(!tv) return;
    tv.textContent = money(total());
  }

  /* ---- BUILD page: upgrade cards ---- */
  function wireUpgrades(){
    $$('.upcard').forEach(function(card){
      var id=card.getAttribute('data-id'); if(!id) return;
      if(state.upgrades[id]) card.classList.add('added');
      // 2026-09-23: the icon tile swaps to a check mark in the added state (option C).
      // Injected once here rather than in the section markup, so one file carries the
      // whole added-state behaviour instead of touching both section liquids.
      var uic=$('.uic',card);
      if(uic && !uic.querySelector('.uic-check')){
        uic.insertAdjacentHTML('beforeend','<svg class="uic-check" viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>');
      }
      var add=$('.addbtn',card), disc=$('.disclosebtn',card), body=$('.upbody',card);
      if(add){
        var setLbl=function(){ add.setAttribute('aria-pressed', card.classList.contains('added')?'true':'false'); };
        setLbl();
        // Shared by the button itself and the 2026-09-22 whole-card tap below, so a tap
        // anywhere on the card and a click on the button run the exact same state change
        // exactly once — never two paths that could ever disagree or double-fire.
        var toggle=function(){
          card.classList.toggle('added');
          state.upgrades[id]=card.classList.contains('added');
          save(state); paintFooter(); setLbl();
        };
        add.addEventListener('click',toggle);
        // 2026-09-22 (Gabe): the whole card is now the tap target, not just the add
        // button — but any nested control (the button itself, "What's included", a
        // focus-area test chip) keeps running its OWN handler and must never also
        // toggle the card. closest() on a generic interactive selector covers every
        // nested control without naming each one, so a future addition inside the
        // card is excluded automatically.
        card.addEventListener('click',function(e){
          if(e.target.closest('button, a, [role="button"], input, select, textarea')) return;
          toggle();
        });
        card.setAttribute('tabindex','0');
        card.addEventListener('keydown',function(e){
          if(e.target!==card) return; // a nested button/link handles its own Enter/Space
          if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); }
        });
      }
      if(disc&&body){
        disc.addEventListener('click',function(){
          var open=body.classList.toggle('open');
          disc.setAttribute('aria-expanded', open?'true':'false');
        });
      }
    });
    // Per-base "see everything in…" expanders. Each button owns the panel named by
    // its aria-controls, so Baseline and WBMRI each get their own contents list.
    $$('.base-expand').forEach(function(be){
      var bb=document.getElementById(be.getAttribute('aria-controls'));
      if(!bb) return;
      be.addEventListener('click',function(){
        var o=bb.classList.toggle('open');
        be.setAttribute('aria-expanded', o?'true':'false');
      });
    });
    // base selector — Baseline is the only active base for now; WBMRI is a disabled placeholder ("does nothing")
    function paintBase(){
      var bk=baseKey();
      $$('.baseopt').forEach(function(o){
        var on = o.getAttribute('data-base')===bk;
        o.classList.toggle('sel', on); o.setAttribute('aria-pressed', on?'true':'false');
      });
      // show only the focus areas that belong to this base
      $$('.upcard').forEach(function(card){
        var id=card.getAttribute('data-id');
        var ok = UPGRADES[id] && (UPGRADES[id].base||'baseline')===bk;
        card.hidden = !ok;
        if(!ok && state.upgrades[id]) state.upgrades[id]=false;
        card.classList.toggle('added', !!state.upgrades[id]);
        var ab=$('.addbtn',card); if(ab) ab.setAttribute('aria-pressed', state.upgrades[id]?'true':'false');
      });
      // Show only the disclosure belonging to the selected base, and collapse the
      // other. Previously only the button was hidden, so opening the Baseline list
      // and then switching to WBMRI left the Baseline contents stranded on screen.
      $$('.base-expand').forEach(function(be){
        var mine = (be.getAttribute('data-base') || 'baseline') === bk;
        var bb = document.getElementById(be.getAttribute('aria-controls'));
        be.hidden = !mine;
        if(bb){
          bb.hidden = !mine;
          if(!mine){ bb.classList.remove('open'); be.setAttribute('aria-expanded','false'); }
        }
      });
      save(state); paintFooter();
    }
    $$('.baseopt').forEach(function(opt){
      if(opt.hasAttribute('disabled')) return;
      opt.addEventListener('click',function(){
        state.base = opt.getAttribute('data-base') || 'baseline';
        // the two bases have different add-on catalogues and prices
        ADDONS = addonsFor(state.base);
        paintBase();
      });
    });
    paintBase();
  }

  /* ---- ADD-ONS page ---- */
  function wireAddons(){
    /* The markup carries rows for BOTH bases. Drop the ones that do not belong to the
       selected base before wiring, so a WBMRI customer never sees Baseline pricing and
       never sees the two add-ons that route does not offer. */
    var bk = baseKey();
    $$('.addon[data-base]').forEach(function(row){
      if(row.getAttribute('data-base') !== bk) row.parentNode.removeChild(row);
    });
    // a category whose rows all belonged to the other base is now just a heading
    $$('.addon-group').forEach(function(g){
      if(!g.querySelector('.addon')) g.hidden = true;
    });
    $$('.addon').forEach(function(row){
      var id=row.getAttribute('data-id'); if(!id) return;
      var t=$('.atoggle',row);
      var covered=isCovered(id);
      // An add-on the selected focus area already contains must not be sellable
      // twice. Deselect it, lock the control, and say why.
      if(covered && state.addons[id]){ state.addons[id]=false; save(state); }
      row.classList.toggle('added', !covered && !!state.addons[id]);
      row.classList.toggle('covered', covered);
      var note=$('.an span',row);
      if(note){
        if(covered){
          if(!note.hasAttribute('data-orig')) note.setAttribute('data-orig', note.textContent);
          note.textContent = ADDONS[id].cat + ' · already included in your ' + UPGRADES[ADDONS[id].includedIn].name + ' focus area';
        } else if(note.hasAttribute('data-orig')){
          note.textContent = note.getAttribute('data-orig');
        }
      }
      if(t){
        t.disabled = covered;
        t.setAttribute('aria-disabled', covered?'true':'false');
        t.setAttribute('aria-pressed', row.classList.contains('added')?'true':'false');
        if(!t.hasAttribute('data-wired')){
          t.setAttribute('data-wired','1');
          // 2026-09-23: check mark replaces the rotate-to-x rule (option B). Injected
          // once, guarded by the same data-wired flag as the rest of this block.
          t.insertAdjacentHTML('beforeend','<svg class="a-check" viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>');
          // Shared by the round toggle button and the 2026-09-22 whole-row tap below,
          // so both paths run the exact same state change exactly once — calling the
          // button's own .click() from the row would dispatch a SECOND click event
          // (one for the tap, one synthetic for the button), double-counting the tap
          // wherever clicks are observed. This function is called directly instead.
          var toggle=function(){
            if(isCovered(id)) return;
            row.classList.toggle('added'); state.addons[id]=row.classList.contains('added');
            save(state); paintFooter();
            t.setAttribute('aria-pressed', row.classList.contains('added')?'true':'false');
          };
          t.addEventListener('click',toggle);
          // 2026-09-22 (Gabe): the whole row is now the tap target, not just the round
          // +/- button. A click that started on the button itself (or any other
          // interactive element the row ever gains) is excluded so it is never run
          // twice — the button's own listener above already ran it once.
          row.setAttribute('data-ph','addon-row');
          row.addEventListener('click',function(e){
            if(row.classList.contains('covered')) return;
            if(e.target.closest('button, a, [role="button"], input, select, textarea')) return;
            toggle();
          });
          row.setAttribute('tabindex', covered?'-1':'0');
          row.addEventListener('keydown',function(e){
            if(e.target!==row) return; // the button handles its own Enter/Space
            if(row.classList.contains('covered')) return;
            if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); }
          });
        }
      }
    });
    paintFooter();
  }

  /* ---- SUMMARY page ---- */
  function renderSummary(){
    var box=$('#summaryRows'); if(!box) return;
    var html='';
    var _b=currentBase();
    html+='<div class="srow"><div class="sl"><b>'+_b.name+'</b><span>'+_b.blurb+'</span></div><div class="sv">'+money(_b.price)+'</div></div>';
    Object.keys(UPGRADES).forEach(function(k){
      if(!state.upgrades[k]) return; var u=UPGRADES[k];
      html+='<div class="srow removable" data-up="'+k+'"><div class="sl"><div><b>'+u.name+' focus area</b><span>'+u.tests.join(' · ')+'</span><button class="rm" data-rm-up="'+k+'" type="button">Remove</button></div></div><div class="sv">'+money(u.price)+'</div></div>';
    });
    Object.keys(ADDONS).forEach(function(k){
      if(!state.addons[k] || isCovered(k)) return; var a=ADDONS[k];
      var pv = a.price==null ? '<div class="sv tbd">Price at booking</div>' : '<div class="sv">'+money(a.price)+'</div>';
      html+='<div class="srow removable" data-addon="'+k+'"><div class="sl"><div><b>'+a.name+'</b><span>Add-on · '+a.cat+'</span><button class="rm" data-rm-addon="'+k+'" type="button">Remove</button></div></div>'+pv+'</div>';
    });
    box.innerHTML=html;
    var tv=$('#sumTotal'); if(tv) tv.textContent=money(total());
    // wire removes
    $$('[data-rm-up]',box).forEach(function(b){ b.addEventListener('click',function(){ state.upgrades[b.getAttribute('data-rm-up')]=false; save(state); renderSummary(); }); });
    $$('[data-rm-addon]',box).forEach(function(b){ b.addEventListener('click',function(){ state.addons[b.getAttribute('data-rm-addon')]=false; save(state); renderSummary(); }); });
  }

  /* ---- BOOKING calendar (mock) ---- */
  function wireBooking(){
    var cal=$('#cal'); if(!cal) return;
    var SLOTS=['8:30 AM','9:00 AM','9:30 AM','10:00 AM','11:00 AM','1:30 PM'];
    var label=$('#calMonth'), grid=$('#calDays'), prev=$('#calPrev'), next=$('#calNext');
    var slotsWrap=$('#slots'), slotChips=$('#slotChips'), confirm=$('#confirmBtn');
    var today=new Date(); today.setHours(0,0,0,0);
    var view=new Date(today.getFullYear(), today.getMonth(), 1);
    var maxMonth=today.getMonth()+3;
    var sel = state.date? new Date(state.date) : null;
    var MN=['January','February','March','April','May','June','July','August','September','October','November','December'];
    function draw(){
      label.textContent=MN[view.getMonth()]+' '+view.getFullYear();
      var first=new Date(view.getFullYear(),view.getMonth(),1).getDay();
      var dim=new Date(view.getFullYear(),view.getMonth()+1,0).getDate();
      var h=''; for(var p=0;p<first;p++) h+='<button class="day pad" tabindex="-1" aria-hidden="true"></button>';
      for(var d=1; d<=dim; d++){
        var dt=new Date(view.getFullYear(),view.getMonth(),d); dt.setHours(0,0,0,0);
        var past = dt<today; var wknd = dt.getDay()===0; // mock: clinics closed Sundays
        var dis = past||wknd;
        var selCls = (sel && dt.getTime()===new Date(sel).setHours(0,0,0,0))?' sel':'';
        h+='<button class="day'+(dis?' dis':'')+selCls+'" '+(dis?'disabled':'')+' data-d="'+dt.toISOString()+'">'+d+'</button>';
      }
      grid.innerHTML=h;
      $$('.day:not(.dis):not(.pad)',grid).forEach(function(b){
        b.addEventListener('click',function(){
          sel=new Date(b.getAttribute('data-d')); state.date=sel.toISOString(); state.slot=null; save(state);
          draw(); drawSlots();
        });
      });
      prev.disabled = (view.getFullYear()===today.getFullYear() && view.getMonth()<=today.getMonth());
      next.disabled = (view.getMonth()>=maxMonth);
    }
    function drawSlots(){
      if(!sel){ slotsWrap.style.display='none'; updateConfirm(); return; }
      slotsWrap.style.display='block';
      slotChips.innerHTML = SLOTS.map(function(s){
        return '<button class="slotchip'+(state.slot===s?' sel':'')+'" data-s="'+s+'" type="button" aria-pressed="'+(state.slot===s?'true':'false')+'">'+s+'</button>';
      }).join('');
      $$('.slotchip',slotChips).forEach(function(c){
        c.addEventListener('click',function(){ state.slot=c.getAttribute('data-s'); save(state); drawSlots(); });
      });
      updateConfirm();
    }
    // placeholder calendar mode: gate the confirm button on a chosen date + slot
    function updateConfirm(){ if(confirm) confirm.disabled = !(state.date && state.slot); }
    prev.addEventListener('click',function(){ view.setMonth(view.getMonth()-1); draw(); });
    next.addEventListener('click',function(){ view.setMonth(view.getMonth()+1); draw(); });
    draw(); drawSlots();
  }

  /* ---- checkout: add selected items to cart -> Shopify checkout (works in both calendar modes) ---- */
  var MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
  /* Placeholder-calendar mode only (no booking app on the page). Same grouping
     contract as the EAB path, and deliberately no /cart/clear.js — clearing would
     wipe any checkup already committed for another person. */
  function startCheckout(btn){
    /* ---- a date is MANDATORY on this path too (2026-08-24) ------------------
       This used to write 'Preferred date' only `if(state.date)` and otherwise added
       the whole build with no date at all, then went straight to /checkout — the
       same dateless order the EAB path was fixed for. updateConfirm() already keeps
       the button disabled until a date and a slot are chosen; this is the guard for
       every other way the handler can be reached (a stale enabled button, a keyboard
       activation, a console call). Nothing is added to the cart without a date.
    ---------------------------------------------------------------------- */
    if(!(state.date && state.slot)){
      alert('Please choose a date and a start time for your checkup first — then your selections are added to the cart together.');
      return;
    }
    btn.disabled=true; btn.textContent='Starting checkout…';
    getCart().then(function(cart){
      /* Identity, order and label are three separate fields (2026-08-27 — see the
         note at makeGid()). This path is the third writer of them; it mints exactly
         the way the /cart/add interceptor does, so a placeholder-calendar group is
         indistinguishable from a booked one to everything downstream. The label is
         the rank this group takes in the cart as read a moment ago, and it is
         corrected below anyway. */
      var gid=makeGid(), seq=String(Date.now());
      var props={};
      props[GLABEL]='Checkup '+rankOf(cart, gid); props[GKEY]=gid; props[SKEY]=seq;
      var dd=new Date(state.date);
      props['Preferred date']=MONTHS[dd.getMonth()]+' '+dd.getDate()+', '+dd.getFullYear();
      props['Preferred time']=state.slot;
      // no booking app on the page, so nothing is in the cart yet — add the base too
      return postJSON('/cart/add.js',{items:buildItems(props, null)});
    })
      /* The order is a snapshot of the cart at checkout, and this handler goes
         straight there — so the numbering has to be settled BEFORE the navigation
         or it never is. A failure here must not strand a customer whose cart is
         complete: the label is cosmetic, the booking is not. */
      .then(function(){ return canonicaliseLabels().catch(function(e){
        try{ console.error('[himedi] renumber failed before checkout', e); }catch(_){}
      }); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(e){ btn.disabled=false; btn.textContent='Confirm & checkout'; alert('Could not start checkout: '+(e&&e.message||'error')); });
  }
  /* ---- the confirm button is never enabled without a booking (2026-08-24) ----
     This used to read:  if(!$('#cal')) btn.disabled=false;  — "EAB mode: enable
     confirm so checkout still works". That enables the button unconditionally, with
     no check that an appointment exists for THIS build, and its handler calls
     startCheckout() which adds the whole build carrying only Checkup/_cgid and goes
     straight to /checkout. A one-shot at wire time also cannot see a cart that
     changes afterwards.

     On the live summary page the two are mutually exclusive — the section renders
     #confirmBtn only in the `section.blocks.size == 0` branch, which is the same
     branch that renders #cal — so this state is currently unreachable. It is fixed
     anyway: it is one app-block change away from being reachable, and the fix costs
     nothing. In app mode the button now stays disabled until pinnedDatedBooking()
     says this build has an appointment, is re-evaluated as the cart changes, and routes
     through commitCheckup() (which reconciles against the booked line) rather than
     startCheckout() (which assumes an empty cart and would double-add the base).
  ------------------------------------------------------------------------- */
  function ensureConfirmNote(btn){
    var host = btn.parentNode; if(!host) return null;
    var n = document.getElementById('cfConfirmGate');
    if(n) return n;
    n = document.createElement('p');
    n.id = 'cfConfirmGate';
    n.textContent = 'Choose a date and time for your checkup first — then everything you selected is added to your cart together.';
    n.setAttribute('style','flex-basis:100%;width:100%;margin:8px 0 0;font-size:13px;line-height:1.4;opacity:.85');
    host.appendChild(n);
    return n;
  }
  function wireConfirm(){
    var btn=$('#confirmBtn'); if(!btn) return;
    var appMode = !$('#cal');   // no placeholder calendar on the page → the booking app owns the date
    btn.addEventListener('click',function(){
      if(btn.disabled) return;
      // app mode: commitCheckup carries the booking gate AND the reconcile
      if(appMode){ commitCheckup('checkout', btn); return; }
      startCheckout(btn);
    });
    if(!appMode) return;              // placeholder mode: updateConfirm() owns the gate
    btn.disabled = true;
    var note = ensureConfirmNote(btn);
    var polls = 0;
    function tick(){
      return getCart().then(function(cart){
        var dated = !!pinnedDatedBooking(cart);
        btn.disabled = !dated;
        if(note) note.hidden = dated;
      }).catch(function(){ btn.disabled = true; });
    }
    tick();
    var iv = setInterval(function(){ if(++polls > 150){ clearInterval(iv); return; } tick(); }, 1500);
    // the booking app fires no event we can listen for — re-check shortly after any click
    document.addEventListener('click', function(){ setTimeout(tick, 900); setTimeout(tick, 2600); }, true);
  }

  /* ============================================================
     Checkup grouping
     A single order can contain several people's checkups. Shopify gives us a flat
     list of line items with no notion of "these belong together", so we stamp every
     line of one build with the same group key. Two properties on purpose:
       "Checkup"  visible — shows in cart, admin, packing slip and the confirmation
                  email, so the Korea team can read the order without tooling
       "_cgid"    hidden (underscore-prefixed) — the stable machine key we match on
     Because the properties differ per group, Shopify keeps each person's lines
     separate instead of merging two identical baselines into one qty-2 line.
     Who each group belongs to is collected afterwards in a follow-up form; this
     only has to guarantee that the grouping itself is unambiguous.
     ============================================================ */
  var GKEY='_cgid', GLABEL='Checkup', SKEY='_cseq';
  /* ---- CART SCHEMA STAMP (2026-08-26, September cutover) ----------------
     Before this build a checkup was a Baseline line PLUS separate focus-area
     lines. It is now ONE Checkup variant. Shopify carts live 14 days, so a cart
     built under the old shape outlives the theme swap -- and the reconcile below
     cannot see it. The old focus-area variants are not in BASE_VARIANTS, so a
     group holding nothing but a Brain line reads as base-less: pinIsStale() says
     the pin is fine, diff() calls the whole combo missing, and the reconcile adds
     a $1,179 Brain combo ON TOP of the $880 Brain line. Neither guard catches it
     -- the over-add check counts base lines and finds 0+1 <= 1, and verify's
     extraBases is empty because the stray line is not a base variant either.
     Every line this build writes carries the stamp. A group that holds lines and
     carries the stamp on NONE of them was written by the old code, and nothing in
     it can be reconciled against. Version rather than a variant blacklist on
     purpose: the next model change gets this for free. */
  var VKEY='_cv', CART_SCHEMA='2';

  /* ---- our own requests are marked, and the interceptor leaves them alone -----
     wireWbmriVariantSwap() monkey-patches window.fetch and rewrites EVERY /cart/add
     body. postJSON called the bare global fetch, so the reconcile's own add was
     rewritten too: it asked for the $1,700 MRI variant and the interceptor turned it
     into the $1,999 MRI+Checkup combo. That is the extra combo line on order #3208.
     The flag below is read by the interceptor, which passes our requests straight
     through. It is a plain property on the init object — fetch ignores unknown
     members, so nothing else sees it. (2026-08-24)
  ------------------------------------------------------------------------- */
  function postJSON(url, body){
    var init = { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) };
    init.__himediInternal = true;          // do not rewrite: this request is ours
    return fetch(url, init)
      .then(function(r){
        if(!r.ok) return r.json().then(function(e){ throw new Error(e.description||e.message||'Cart error'); });
        return r.json();
      });
  }
  /* Never reconcile against a cached cart. Every add this file makes is decided by
     diffing the wanted build against what /cart.js reports the group already holds,
     so one stale read makes the whole group look empty and the entire build gets
     added a second time — which is the shape of the duplicate lines on #3208.
     cache:'no-store' plus a cache-buster, because the two are defeated by different
     layers. */
  /* ---- the last cart we actually read --------------------------------------
     GROUP IDENTITY IS ASSIGNED AT BIRTH (2026-08-27). The /cart/add interceptor
     below stamps the group key onto the booking request itself, and it has to
     decide the ordinal SYNCHRONOUSLY: the booking app posts through axios's
     XMLHttpRequest adapter, and XMLHttpRequest.prototype.send cannot be made to
     await a /cart.js round trip. So every read keeps a snapshot here and the mint
     derives its ordinal from that, from the mints it has already handed out, and
     from the pin. On the review-and-book page check() reads the cart on arrival
     and again every 1.2s, so the snapshot is at most about a second old at the
     moment the customer confirms a time.
     A stale snapshot cannot merge two people: the group KEY carries a random
     suffix and is unique regardless. The worst it can do is print the same
     ordinal twice, which is a visible, harmless label collision — the direction
     this system is supposed to fail in. */
  var CART_SNAPSHOT = null;
  function getCart(){
    var init = { headers:{'Accept':'application/json'}, cache:'no-store' };
    init.__himediInternal = true;
    return fetch('/cart.js?_=' + Date.now(), init).then(function(r){ return r.json(); })
      .then(function(c){ CART_SNAPSHOT = c; return c; });
  }

  /* ---- THREE FIELDS, THREE JOBS (2026-08-27) --------------------------------
     Until today ONE string did all three jobs at once. `_cgid` = "c8-kqzfhx" was
     simultaneously the identity of a person, the sort key the cart page ordered on,
     AND the customer-visible number. That is why the number could not be corrected
     without breaking identity, and why identity could not be minted without first
     reading the cart to find max+1. They are now three fields:

       _cgid    IDENTITY — which person this line belongs to. 'g-' plus 10 random
                letters. NO ordinal, nothing derived from the cart, nothing that can
                go stale. NEVER rewritten, by anything, ever.
       _cseq    ORDER — a stable total ordering of groups by mint time.
                String(Date.now()) at mint, ties broken lexicographically by _cgid.
                Never rewritten except by the one-time migration of a cart that
                predates the field (canonicaliseLabels() below).
       Checkup  DISPLAY — what the customer, the picker and Korea read.
                'Checkup ' + rank, where rank is the 1-based position of
                (_cseq, _cgid) among the groups CURRENTLY in the cart. The only
                field the renumber touches.

     Two things follow, and they are the whole point:
       * the number is no longer identity, so recomputing it cannot merge, split or
         re-point a group. The worst a broken renumber can do is print the wrong
         number — provided the write envelope in setLineProps() holds.
       * identity carries no ordinal, so a mint does not have to read the cart. That
         is what deleted the himedi_minted_gids_v1 ledger; see mintGroupForAdd().

     `Checkup` has no leading underscore, so Shopify puts it on the order, the
     packing slip and the confirmation email as well as the cart. That is why the
     LINE PROPERTY has to be corrected and a display-only fix in main-cart.liquid
     was rejected: it would have left the email saying "Checkup 8" while the cart
     said "Checkup 1", which is worse than the bug, because the two disagreeing
     numbers reach two different people.

     THE COLLISION THIS STILL CLOSES (order #3208, 2026-08-24). The id used to be
     max-of-the-cart plus one, re-derived on every reload, back button and second
     tab, so two different people's checkups both ended up stamped c1 and became
     indistinguishable. Dropping the ordinal and keeping only the random token makes
     the key MORE unique, not less: nothing about it is derived from position.
  ------------------------------------------------------------------------- */
  function gidToken(n){
    var A='abcdefghijklmnopqrstuvwxyz', out='', arr=null, i;
    n = n || 10;
    try{ if(window.crypto && window.crypto.getRandomValues){ arr=new Uint8Array(n); window.crypto.getRandomValues(arr); } }catch(e){}
    for(i=0;i<n;i++){ out += A.charAt((arr ? arr[i] : Math.floor(Math.random()*256)) % 26); }
    return out;
  }
  function makeGid(){ return 'g-' + gidToken(10); }

  /* An id written before today: "c8-kqzfhx", or the pre-2026-08-24 "c8". Returns
     its legacy ordinal, or null for a current opaque id. This is the ONLY code left
     that parses digits out of a _cgid, and it exists solely so an in-flight cart
     keeps the order it already had until its first canonicalise writes a real
     _cseq. A current id carries no digits at all, so the two shapes cannot be
     confused for one another. */
  function legacyOrdinal(gid){
    var m = /^c(\d+)(?:-|$)/.exec(String(gid||''));
    return m ? parseInt(m[1],10) : null;
  }
  /* The sort key for a group, as a fixed-width digit string, so a plain string
     compare orders it correctly HERE and in main-cart.liquid — which renders in
     Liquid and has no numeric sort at all. 16 digits: Date.now() is 13 and stays 13
     until the year 2286. A legacy group ranks by its ordinal, which pads to a value
     below every epoch-based one, so carts that predate _cseq sort ahead of anything
     minted after it. That is true, and it is what stops a migration reordering a
     cart the customer is already looking at. */
  function seqKey(seq){
    var s = String(seq == null ? '' : seq).replace(/\D/g,'');
    if(!s) s = '0';
    return ('0000000000000000' + s).slice(-16);
  }

  /* ---- MINTING A GROUP AT /cart/add TIME (2026-08-27) ----------------------
     THE BUG THIS REPLACES. stampUntagged() used to claim the FIRST cart line
     with no _cgid, positionally, with no ownership test of any kind, and recurse
     over all of them. Its correctness depended on an invariant nothing enforced
     — "the cart holds at most one unclaimed line and that line is mine" — and
     four ordinary sequences break it:
       B  an orphan left by an earlier booking is absorbed by the next person;
       C  two bookings arrive before the first commit pass and it claims both;
       D  two tabs: tab A claims tab B's line, and tab B then never commits at all.
     In every one of them runCommit DID detect the collision, three steps too
     late — the merge was already written — and on the automatic pass the throw
     was swallowed silently. The customer saw one clean CHECKUP N with one date
     while two people's appointments sat under it, and /cart's Checkout worked.

     THE FIX. A line that is born tagged can never be claimed by someone else, so
     the group is minted here and written into the /cart/add body itself, on the
     one request that carries the appointment. Positional claiming is then not
     merely guarded against, it is gone: nothing in this file adopts a line it did
     not create. If some future add path escapes the interceptor the result is an
     ORPHAN — visible under "Other items", carrying its own date, blocked by the
     cart gate — rather than a MERGE, which is invisible and waved through. That
     is the right way for this system to fail.

     THE ORDINAL IS GONE FROM HERE (2026-08-27). It used to be max-of-the-cart plus
     one, because the visible "Checkup N" label and main-cart.liquid's ordering both
     read the digits out of _cgid — and computing a max means reading /cart.js,
     which this function CANNOT do: the booking app posts through
     XMLHttpRequest.prototype.send and that cannot be made to await a round trip.
     The entire apparatus built to work around that is deleted along with it:

       * the himedi_minted_gids_v1 ledger in localStorage, and its TTL prune;
       * the max-scan over CART_SNAPSHOT, and the pin's contribution to the max.

     Their only job was to make max+1 safe across two tabs sharing one stale
     snapshot. A random _cgid and a Date.now() _cseq are safe across two tabs by
     construction, so the job no longer exists. Minting now reads NOTHING — not the
     cart, not localStorage — which is what makes it correct to do synchronously
     inside an XHR send(). */
  /* Synchronous on purpose — see the note on CART_SNAPSHOT. Sets the pin as well
     as returning the key: the pin is what runCommit reconciles into, and
     persisting it here means a reload, or a second pass, re-adopts THIS booking's
     group instead of looking like a new person. */
  function mintGroupForAdd(){
    var gid = makeGid(), seq = String(Date.now());
    COMMIT_SEQ = seq; COMMIT_GID = gid;
    /* A newly minted group is never sealed: the seal belonged to the group the pin
       just left, and that group is unreachable without the pin. */
    SEALED_GID = null; state.sealedGid = null; state.committedBuild = null;
    state.committedSeq = seq; state.committedGid = gid; save(state);
    return { gid:gid, seq:seq };
  }
  /* How many distinct groups the last cart we read held, plus one — the provisional
     rank for a group being minted right now, before it is in any cart we have seen.
     Display only. canonicaliseLabels() settles it. */
  function provisionalRank(){
    var seen={}, n=0;
    ((CART_SNAPSHOT && CART_SNAPSHOT.items) || []).forEach(function(it){
      var g=(it.properties||{})[GKEY];
      if(g && !seen[g]){ seen[g]=1; n++; }
    });
    return n+1;
  }

  /* ---- what counts as a real appointment date ------------------------------
     Read off live orders (#3203–#3214): every booked line carries Date ("October 6,
     2026"), _Start Date, Time, _Start Time, _Event # and _Booked With. The dateless
     lines this file used to create carry nothing but Checkup/_cgid. Any property
     whose NAME contains "date" counts, so the check survives the booking app
     renaming its private keys, and the placeholder path's own 'Preferred date'
     satisfies it too. */
  var DATE_KEYS = ['Date', '_Start Date', 'Preferred date'];
  function lineDate(it){
    var p=(it && it.properties) || {}, i, k;
    for(i=0;i<DATE_KEYS.length;i++){ if(p[DATE_KEYS[i]]) return String(p[DATE_KEYS[i]]); }
    for(k in p){ if(Object.prototype.hasOwnProperty.call(p,k) && /date/i.test(k) && p[k]) return String(p[k]); }
    return null;
  }
  function isDatedBookingLine(it){ return !!lineDate(it) && isBookingLine(it); }
  // every distinct appointment date inside one group — a healthy group has exactly one
  function groupDates(cart, gid){
    var seen={}, out=[];
    (cart.items||[]).forEach(function(it){
      if((it.properties||{})[GKEY] !== gid) return;
      var d = lineDate(it);
      if(d && !seen[d]){ seen[d]=1; out.push(d); }
    });
    return out;
  }

  /* The three variants that ARE a checkup rather than an extra on one. Note that
     UPGRADES.checkup reuses the Baseline variant (it is the Baseline sold as an
     upgrade on the MRI route), so one build can legitimately want two of these —
     which is why the guards below compare against what the build asks for rather
     than assuming one. */
  var BASE_VARIANTS = [Number(BASES.baseline.variant), Number(BASES.wbmri.variant),
                       Number(WBMRI_COMBO_VARIANT)].concat(ALL_COMBO_VARIANTS)
                       .concat(Object.keys(WBMRI_PROMO_TO_STD).map(Number));
  function isBaseVariant(v){ return BASE_VARIANTS.indexOf(Number(v)) !== -1; }

  /* Groups written before the schema stamp existed. A group counts as legacy only
     when it holds lines and not one of them carries the current stamp -- a group
     half-written by this build (EAB's line stamped, the rest still to come) is
     therefore never legacy. Ungrouped lines are never touched: the appointment EAB
     just created is untagged and is not ours to delete. */
  function legacyGroups(cart){
    var seen={}, stamped={}, out=[];
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(!p[GKEY]) return;
      seen[p[GKEY]]=1;
      if(p[VKEY] === CART_SCHEMA) stamped[p[GKEY]]=1;
    });
    Object.keys(seen).forEach(function(g){ if(!stamped[g]) out.push(g); });
    return out;
  }
  /* Remove them. Not "migrate": the old lines are bound to EAB events this page no
     longer renders (the summary template now carries one Checkup calendar, not
     baseline/brain/cancer), so the old appointment cannot be carried forward and
     pretending otherwise is how a dateless order reaches Korea.
     The PIN is released with them -- committedGid pointed into the group we just
     deleted -- but the SELECTIONS are deliberately kept. resetBuild() would wipe the
     checkup the customer spent three screens choosing; all they actually have to do
     is pick a date again, and the next pass then reconciles the same build into a
     fresh group. The customer is told plainly, because their cart changed under
     them. */
  function purgeLegacy(cart, note){
    var dead = legacyGroups(cart);
    if(!dead.length) return Promise.resolve(cart);
    var updates={}, n=0;
    (cart.items||[]).forEach(function(it){
      if(dead.indexOf((it.properties||{})[GKEY]) === -1) return;
      if(!it.key) return;
      updates[it.key]=0; n++;
    });
    if(!n) return Promise.resolve(cart);
    if(note) note('legacy cart', { groups:dead, lines:n });
    try{ console.warn('[himedi] clearing ' + n + ' cart line(s) built before the current checkup model:', dead); }catch(_){}
    try{ window.HIMEDI_LEGACY_PURGE = { groups:dead, lines:n, at:Date.now() }; }catch(_){}
    return postJSON('/cart/update.js', { updates:updates }).then(function(){
      COMMIT_SEQ = null; COMMIT_GID = null;
      SEALED_GID = null; state.sealedGid = null; state.committedBuild = null;
      state.committedSeq = null; state.committedGid = null; save(state);
      throw LEGACY;
    });
  }

  // every variant id currently sitting inside one group
  function groupVariants(cart, gid){
    var out=[];
    (cart.items||[]).forEach(function(it){
      if((it.properties||{})[GKEY] === gid) out.push(Number(it.variant_id));
    });
    return out;
  }

  /* ---- ONE CHECKUP PER GROUP (2026-08-26) ---------------------------------
     COMMIT_GID pins a group so a second pass reconciles INTO it instead of
     opening a new one -- that is what stops a reload from duplicating a checkup.
     (It was COMMIT_GROUP, an ordinal, until 2026-08-27. The ordinal is no longer
     identity and is no longer pinned; COMMIT_SEQ carries the group's position.)
     But the pin also survives a customer who goes back and builds a DIFFERENT
     checkup without pressing "add another checkup". Both then land under one
     header: the Korea team cannot tell which appointment belongs to which person,
     the reconcile treats the other checkup's lines as its own, and the duplicate
     guard blocks checkout with "would be over-charged" -- which is exactly the
     CHECKUP 4 cart Gabe hit on 2026-08-26, holding Baseline+Brain AND a bare
     Baseline in one group.

     The rule is simply: a group holds exactly one checkup. If the pinned group
     already carries a base line and it is not the one this build is asking for,
     the pin belongs to someone else's checkup -- drop it and open a new group. */
  function pinIsStale(cart){
    if(COMMIT_GID == null) return false;
    var have = groupVariants(cart, COMMIT_GID);
    var haveBase = have.filter(isBaseVariant);
    if(!haveBase.length) return false;          // nothing committed into it yet
    var wantBase = wantFor(have).filter(isBaseVariant);
    if(!wantBase.length) return false;          // this build wants no base line
    /* every base line this build wants is already present -> same checkup, keep the
       pin. Otherwise this is a different checkup wearing someone else's group. */
    return wantBase.some(function(v){ return haveBase.indexOf(Number(v)) === -1; });
  }

  /* The wanted set, adjusted for what the group already holds. Was inlined in three
     places with two slightly different versions; the extra-line check below needs it
     to be exactly one. When the combo line is present it IS the base line for this
     build, so it is put INTO the wanted set rather than left unaccounted — otherwise
     every combo booking looks like an unexpected extra. */
  function wantFor(have){
    var want = desiredVariants().map(Number);
    var comboPromo = Number(WBMRI_STD_TO_PROMO[String(WBMRI_COMBO_VARIANT)]);
    var comboHeld = have.indexOf(Number(WBMRI_COMBO_VARIANT)) !== -1 ? Number(WBMRI_COMBO_VARIANT)
                  : (have.indexOf(comboPromo) !== -1 ? comboPromo : 0);   // 2026-10-13: its Promo twin is the combo too
    if(comboHeld){
      want = want.filter(function(v){
        return v !== Number(BASES.wbmri.variant) && v !== Number(BASES.baseline.variant);
      });
      want.unshift(comboHeld);
    }
    /* SEPTEMBER RECONCILE, 2026-08-26.
       desiredVariants() always names the STANDARD Checkup variant, because at build
       time no date has been chosen yet. By the time this runs the customer HAS picked
       a date, and if it fell in September the add-to-cart rewrite already put the
       September twin in the cart. Without this, diff() sees the standard variant as
       missing and the September one as an unexpected extra, so the reconcile adds a
       SECOND checkup line and the duplicate guard then refuses to check out --
       exactly the shape of the #3208 over-charge. If the group already holds the
       September twin of something we want, that twin IS the line: adopt it. */
    want = want.map(function(v){
      var sep = STD_TO_SEP[String(v)];
      if(sep && have.indexOf(Number(sep)) !== -1) return Number(sep);
      var promo = WBMRI_STD_TO_PROMO[String(v)];   // 2026-10-13: same adoption for the WBMRI ended promo twin
      return (promo && have.indexOf(Number(promo)) !== -1) ? Number(promo) : v;
    });
    return want;
  }
  // multiset difference: what the group is short of, and what it holds beyond the build
  function diff(have, want){
    var pool = have.slice(), missing = [];
    want.forEach(function(v){
      var i = pool.indexOf(v);
      if(i !== -1) pool.splice(i,1); else missing.push(v);
    });
    return { missing:missing, extra:pool };
  }
  // an untagged line carrying properties is the appointment EAB just created
  function pendingBooking(cart){
    var found=null;
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(!p[GKEY] && Object.keys(p).length) found=it;
    });
    return found;
  }

  /* ---- what proves a real booking exists -----------------------------------
     pendingBooking() only sees an UNTAGGED line, so it stops being true the moment
     the commit stamps the group — and it is never true if the customer simply never
     booked. Neither case is the same question as "is there an appointment in this
     cart", which is what the cart must be gated on.

     EAB always writes its own line-item properties alongside the variant. Verified
     against live orders: every healthy order (#3106, #3107, #3108, #3111, #3114)
     carries a line with "_Event #" plus Date/Time/_Booked With; every dateless order
     (#3104, #3105, #3110, #3113) carries lines with ONLY Checkup/_cgid — the
     signature of this file's own reconcile running with no booking present.
     "_Event #" is therefore the discriminator, with Date+Time as a fallback in case
     the app ever renames its private keys.

     Deliberately generous. A false negative here blocks a customer who HAS booked
     from checking out, which is far worse than a false positive, so anything the
     booking app wrote counts — the named keys, Date+Time, or simply any property
     that is not one of our own two group tags. The only cart this rejects is one
     whose lines carry nothing but Checkup/_cgid, which is precisely the broken
     state and is a thing only this file can produce. */
  var BOOKING_KEYS = ['_Event #', '_Booked With', '_Start Date'];
  function isBookingLine(it){
    var p = (it && it.properties) || {};
    for(var i=0;i<BOOKING_KEYS.length;i++){ if(p[BOOKING_KEYS[i]]) return true; }
    if(p['Date'] && p['Time']) return true;
    // anything the app wrote that is not one of ours
    /* EVERY field this file writes has to be listed here. VKEY was the first trap:
       without it a line carrying only Checkup/_cgid/_cv counts as a booking and the
       dateless-order gate stops firing. SKEY (_cseq, 2026-08-27) is the same trap
       and was added with the field itself — a line carrying only our own four tags
       is precisely the broken state this clause exists to reject, and it is a state
       only this file can produce. If you add a fifth property, add it here too. */
    return Object.keys(p).some(function(k){
      return k !== GKEY && k !== GLABEL && k !== VKEY && k !== SKEY;
    });
  }
  function hasBooking(cart){
    var found=null;
    (cart.items||[]).forEach(function(it){ if(isBookingLine(it)) found=it; });
    return found;
  }

  /* ================= THE RENUMBER WRITE, FENCED (2026-08-27) =================
     /cart/change.js is the only endpoint that can write a line property
     (/cart/update.js cannot — checked against the Shopify AJAX Cart API reference),
     and that reference is explicit:

       "Whenever a POST request includes properties, it overwrites the entire
        properties object. Any key-value pairs that were already in the properties
        object are erased."

     Losing EAB's Date / _Start Date / _Event # that way is precisely what produced
     the dateless orders #3104, #3105, #3110 and #3113. So the renumber gets ONE
     write primitive, and setLineProps() is the only function in this file permitted to
     call /cart/change.js. Do not add a second one.

     PRECISELY WHAT THAT CLAIM IS, because a wider version of it was written here first
     and was false. There are exactly TWO callers of /cart/change.js in this theme,
     found by scanning all 369 of its text assets on 2026-08-27:
       * this one, and its twin in sections/main-cart.liquid (the cart page loads no
         script of ours, so the primitive is written out twice on purpose);
       * assets/theme.js, the stock Dawn <line-item-quantity> stepper, which fires on
         every quantity click. Measured in the served bundle, its body is
         {id, quantity, sections} — it never sends `properties`, so it cannot erase an
         EAB property and cannot re-key a line. It is not a participant in grouping and
         contains zero occurrences of _cgid, _cseq or any ordinal symbol.
     So the true invariant is: setLineProps() is the only thing in this theme that
     WRITES LINE PROPERTIES. That is the one worth defending.

     Four things below are deliberate and each closes a live hole:

       * `id: lineKey`, NOT `line: index`. /cart/change.js accepts the line-item KEY
         as id. It also RE-KEYS and can RE-ORDER lines, which is why the deleted
         stampUntagged() had to re-read the cart between every single stamp — a
         cached index is not safe. Key-addressing removes that whole failure class.
       * `quantity` is sent explicitly. The docs: "You cannot update only
         properties; you must also specify quantity." stampUntagged() omitted it.
         That never bit, because one line is one person at quantity 1, but it was a
         documented contract violation sitting in the most dangerous call in the
         file. It is read off the cart we JUST read, never off a cached one.
       * steps 5 and 6 turn "we merge, so nothing is lost" from an intention into a
         checked precondition. stampUntagged() merged correctly — but nothing
         verified that it had, so a future edit to the merge loop would have lost
         bookings silently. The assert makes that regression impossible to ship.
       * the renumber patch is exactly one key, `{ Checkup: 'Checkup ' + n }` (two,
         once, for a cart being migrated). _cgid, _cv, _cseq and every EAB key are
         carried through by construction AND checked by the assert. That is the
         entire blast radius.

     On an assert failure NOTHING is written, window.HIMEDI_RENUMBER records which
     key and which line, and the throw stops the whole pass.
  ========================================================================= */
  /* Every key that must be byte-identical across the write: the date keys, the
     booking keys, and anything either side names date or time — so the fence
     survives the booking app renaming its private properties. */
  function fencedKeys(pre, merged){
    var keys={}, k, i;
    for(i=0;i<DATE_KEYS.length;i++) keys[DATE_KEYS[i]]=1;
    for(i=0;i<BOOKING_KEYS.length;i++) keys[BOOKING_KEYS[i]]=1;
    for(k in pre){ if(Object.prototype.hasOwnProperty.call(pre,k) && /date|time/i.test(k)) keys[k]=1; }
    for(k in merged){ if(Object.prototype.hasOwnProperty.call(merged,k) && /date|time/i.test(k)) keys[k]=1; }
    return Object.keys(keys);
  }
  function renumberAbort(k, lineKey, why){
    try{ window.HIMEDI_RENUMBER = { abort:k, line:lineKey, why:why, at:Date.now() }; }catch(_){}
    try{ console.error('[himedi renumber] refusing to write', { key:k, line:lineKey, why:why }); }catch(_){}
    throw new Error('renumber aborted on ' + k);
  }
  function setLineProps(lineKey, patch){
    // 1. read the cart fresh. NEVER merge onto a snapshot you did not just read.
    return getCart().then(function(cart){
      var items = cart.items || [], line = null, i, k;
      // 2. address by key
      for(i=0;i<items.length;i++){ if(items[i].key === lineKey){ line = items[i]; break; } }
      if(!line) renumberAbort('(line gone)', lineKey, 'line is not in the cart any more');

      var pre = line.properties || {};           // 3.
      var merged = {};                           // 4.
      for(k in pre){ if(Object.prototype.hasOwnProperty.call(pre,k)) merged[k] = pre[k]; }
      for(k in patch){ if(Object.prototype.hasOwnProperty.call(patch,k)) merged[k] = patch[k]; }

      // 5. a patch may only ADD or CHANGE a key — never DROP one
      for(k in pre){
        if(!Object.prototype.hasOwnProperty.call(pre,k)) continue;
        if(!Object.prototype.hasOwnProperty.call(merged,k)) renumberAbort(k, lineKey, 'the merge dropped a key');
      }
      // 6. nothing that carries an appointment may change, ever
      var fenced = fencedKeys(pre, merged);
      for(i=0;i<fenced.length;i++){
        k = fenced[i];
        if(pre[k] === undefined) continue;
        if(merged[k] !== pre[k]) renumberAbort(k, lineKey, 'the patch would change a booking property');
      }

      var qty = line.quantity || 1;
      var vid = String(line.variant_id);
      // 7.
      return postJSON('/cart/change.js', { id: lineKey, quantity: qty, properties: merged })
        .then(function(){ return getCart(); })
        .then(function(after){
          // 8. VERIFY. A properties write RE-KEYS the line, so matching on the old
          //    key first and on (group, variant, new label) second is the normal
          //    path here, not the exceptional one.
          var l2 = after.items || [], now = null, j, p;
          for(j=0;j<l2.length;j++){ if(l2[j].key === lineKey){ now = l2[j]; break; } }
          if(!now){
            for(j=0;j<l2.length;j++){
              p = l2[j].properties || {};
              if(p[GKEY] === merged[GKEY] && String(l2[j].variant_id) === vid && p[GLABEL] === merged[GLABEL]){ now = l2[j]; break; }
            }
          }
          if(!now) renumberAbort('(line lost)', lineKey, 'the line is missing after the write');
          if((now.quantity||1) !== qty) renumberAbort('quantity', lineKey, 'quantity changed ' + qty + ' -> ' + now.quantity);
          var np = now.properties || {};
          for(i=0;i<fenced.length;i++){
            k = fenced[i];
            if(pre[k] === undefined) continue;
            if(np[k] !== pre[k]) renumberAbort(k, lineKey, 'a booking property did not survive the write');
          }
          return now;
        });
    });
  }

  /* ---- the canonical numbering, and the no-op rule --------------------------
     Group the cart by _cgid, order the groups by (_cseq, _cgid), and the rank of a
     group is its 1-based position. Nothing here reads a digit out of _cgid except
     legacyOrdinal(), and that only for a group that has no _cseq yet. */
  function canonicalGroups(cart){
    var order=[], byGid={};
    (cart.items||[]).forEach(function(it){
      var p = it.properties || {}, g = p[GKEY];
      if(!g) return;                                   // ungrouped: never ours
      if(!byGid[g]){ byGid[g] = { gid:g, seq:null, lines:[] }; order.push(byGid[g]); }
      if(byGid[g].seq == null && p[SKEY]) byGid[g].seq = String(p[SKEY]);
      byGid[g].lines.push(it);
    });
    order.forEach(function(grp){
      grp.legacy = (grp.seq == null);
      /* An in-flight group keeps the position its old ordinal already gave it. A
         legacy ordinal pads below every epoch value, so migrating a cart never
         reorders what the customer is already looking at. */
      grp.seqOut = grp.legacy ? String(legacyOrdinal(grp.gid) || 0) : grp.seq;
      grp.sort = seqKey(grp.seqOut);
    });
    order.sort(function(a,b){
      if(a.sort !== b.sort) return a.sort < b.sort ? -1 : 1;
      return a.gid < b.gid ? -1 : (a.gid > b.gid ? 1 : 0);   // ties: lexicographic on _cgid
    });
    return order;
  }
  // the rank a group holds in a cart we have already read — display only
  function rankOf(cart, gid){
    var gs = canonicalGroups(cart), i;
    for(i=0;i<gs.length;i++){ if(gs[i].gid === gid) return i+1; }
    return gs.length + 1;
  }
  /* The label and sort key a group is already wearing, so a pass that adds lines to
     it writes the same strings onto them and canonicaliseLabels() then finds nothing
     to correct. Never derived, never guessed: read off the cart. */
  function groupFields(cart, gid){
    var label=null, seq=null;
    (cart.items||[]).forEach(function(it){
      var p = it.properties || {};
      if(p[GKEY] !== gid) return;
      if(label == null && p[GLABEL]) label = String(p[GLABEL]);
      if(seq   == null && p[SKEY])   seq   = String(p[SKEY]);
    });
    return { label: label || ('Checkup ' + rankOf(cart, gid)), seq: seq };
  }

  /* ---- canonicaliseLabels() -------------------------------------------------
     Make the customer-visible label read 1..N with no gaps — in the cart, and
     therefore on the order, the packing slip and the confirmation email, because
     the order is a snapshot of the cart at checkout and `Checkup` is on all four.

     THE NO-OP RULE. It computes the canonical numbering, diffs it against what the
     lines actually SAY, and writes ONLY the lines that disagree. A settled cart does
     ZERO /cart/change.js calls. That is the entire point of the risk analysis above:
     the dangerous operation runs only when the numbering is genuinely wrong.

     IN-FLIGHT CARTS ARE MIGRATED, NOT PURGED. A group written before today carries
     no _cseq. It is ranked by the legacy ordinal still in its old _cgid, and the
     first canonicalise writes _cseq in the SAME patch as Checkup — the only patch
     that ever carries two keys. _cv is deliberately NOT bumped: a schema bump routes
     these carts into purgeLegacy() and the cart page's orphan sweep, both of which
     DELETE the customer's lines. That is a proportionate answer to a model change
     that made the lines unpriceable and a wildly disproportionate one to a numbering
     change, and real customers are holding these carts right now.

     Serialized by its callers, never by itself: on the summary page it runs inside
     commitQueue, so it cannot interleave with a commit; on the cart page
     main-cart.liquid guards it against re-entry and runs it AFTER the orphan sweep,
     because the sweep can delete whole groups. */
  function canonicaliseLabels(){
    return getCart().then(function(cart){
      var groups = canonicalGroups(cart), writes = [];
      groups.forEach(function(grp, i){
        var label = 'Checkup ' + (i+1);
        grp.lines.forEach(function(it){
          var p = it.properties || {}, patch = null;
          if(p[GLABEL] !== label){ patch = patch || {}; patch[GLABEL] = label; }
          if(!p[SKEY] && grp.seqOut != null){ patch = patch || {}; patch[SKEY] = grp.seqOut; }
          if(patch && it.key) writes.push({ key:it.key, patch:patch });
        });
      });
      if(!writes.length){
        /* Say so out loud. "It did nothing" and "it never ran" look identical from
           the Network tab, and T-N4 is the difference between them. */
        try{ window.HIMEDI_RENUMBER = { wrote:0, groups:groups.length, at:Date.now() }; }catch(_){}
        return { wrote:0, groups:groups.length };
      }
      try{ window.HIMEDI_RENUMBER = { planned:writes.length, groups:groups.length, at:Date.now() }; }catch(_){}
      var i = 0;
      function step(){
        if(i >= writes.length) return Promise.resolve();
        var w = writes[i++];
        return setLineProps(w.key, w.patch).then(step);
      }
      return step().then(function(){
        try{ window.HIMEDI_RENUMBER = { wrote:writes.length, groups:groups.length, at:Date.now() }; }catch(_){}
        return { wrote:writes.length, groups:groups.length };
      });
    });
  }

  /* ---- the appointment THIS build owns --------------------------------------
     DATELESS-ADD REGRESSION, 2026-08-11. hasBooking() answers "is there an
     appointment anywhere in this cart", but every caller actually needs "has an
     appointment been made for the build on this page". Those are the same question
     only for the very first person in an order, which is why it tested clean.

     For the second person they diverge completely. Person 1 books; their line
     carries _Event # + Date + Time and is stamped c1. The customer clicks "Add
     another checkup", builds person 2, and lands on review-and-book. hasBooking()
     sees PERSON 1's appointment, returns true, and the automatic pass commits
     person 2's entire build into a fresh group with no date at all — on arrival,
     before they have touched the calendar. That is the reported symptom: landing
     on the page adds to cart.

     THE PREVIOUS ANSWER, AND WHY IT WAS STILL WRONG (fixed 2026-08-27). This used
     to be ownBooking(): "ours if it carries our group tag, OR if it carries no tag
     at all — EAB just made it, so it is ours to claim." That second clause is the
     positional guess. It cannot tell a booking this page made from an orphan left
     behind by an earlier one or by another tab, and it is what let one person's
     commit adopt another person's appointment (routes B, C and D).

     Ownership is now settled at /cart/add time — mintGroupForAdd() writes the group
     onto the request that carries the appointment — so the question has an exact
     answer with no inference in it: a dated booking line inside the pinned group.
     An untagged line is never adopted by anybody. It stays an orphan, visibly,
     under "Other items", which is the failure this system is meant to have.

     Dated, not merely "the app touched it": isBookingLine() is deliberately
     generous, but an appointment with no date is the thing we are trying to
     prevent, so every gate uses this stricter form. (2026-08-24)
  ------------------------------------------------------------------------- */
  function pinnedDatedBooking(cart){
    if(COMMIT_GID == null) return null;
    var items = cart.items || [];
    for(var i=0;i<items.length;i++){
      var it = items[i];
      if((it.properties||{})[GKEY] !== COMMIT_GID) continue;
      if(isDatedBookingLine(it)) return it;
    }
    return null;
  }
  // On the summary page EAB owns the appointment. Elsewhere (placeholder calendar)
  // the date is gated by updateConfirm() instead and this guard must not apply.
  function eabMode(){ return !!$('.cf-app-slot'); }

  /* ---- stampUntagged() WAS HERE, AND IT IS NOT COMING BACK (2026-08-27) -----
     It claimed the first cart line with no _cgid, positionally, with no ownership
     test, and recursed over all of them. See the note on mintGroupForAdd() for the
     four sequences that broke it and for what replaced it. Nothing in this file
     writes a group tag onto a line it did not itself create any more.

     CORRECTED 2026-08-27 (later): this note used to end "which is why there is no
     /cart/change.js call left in this file at all." That is no longer true and must
     not be restored. There is exactly ONE, in setLineProps(), and it may only ever
     ADD or CHANGE the `Checkup` label — never a group tag, never an EAB property,
     asserted before the write and verified after it. The claim that matters is
     narrower and still holds: no pass in this file decides which group a line
     belongs to after the line exists.

     If you are about to re-add a "just tag whatever is untagged" pass to fix an
     orphan: don't. That is exactly the change that was made on 2026-08-26 and
     rolled back the same day — it turned a visible orphan into a silent merge,
     passed eight stub tests doing it, and was worse in a browser than the bug it
     fixed. An untagged line means the add escaped the interceptor; fix it there.
  ------------------------------------------------------------------------- */

  /* Every variant this build should end up with, base first. */
  function desiredVariants(){
    var out=[];
    if(baseKey() === 'wbmri'){
      /* The MRI route is unchanged: its base and its one upgrade stay separate
         lines, because they are separate products with their own booking event. */
      if(currentBase().variant) out.push(currentBase().variant);
      Object.keys(UPGRADES).forEach(function(k){
        if(state.upgrades[k] && upgradeAvailable(k) && UPGRADES[k].variant) out.push(UPGRADES[k].variant);
      });
    } else {
      /* The checkup route is now ONE line: the Checkup variant for this exact
         combination. Standard here -- the September twin is substituted at
         add-to-cart time, once the chosen appointment date is known. */
      var cv = comboVariant(false);
      if(cv) out.push(cv);
    }
    Object.keys(ADDONS).forEach(function(k){
      if(state.addons[k] && ADDONS[k].variant && !isCovered(k)) out.push(ADDONS[k].variant);
    });
    return out;
  }

  /* Add everything the build needs EXCEPT the one line the booking app already
     created. Which product that is depends on how the event was set up in EAB:
     an event can only own a variant once, so the Brain and Cancer events are bound
     to the Brain and Cancer focus-area products rather than to Baseline. That means
     the booked line is sometimes the base and sometimes a focus area — assuming it
     is always the base would double-charge the focus area and drop the $299 baseline
     entirely. Reading the booked variant off the cart keeps this correct no matter
     which product an event is attached to. */
  function buildItems(props, bookedVariant){
    var want = desiredVariants();
    var booked = bookedVariant ? Number(bookedVariant) : null;
    if(booked && WBMRI_PROMO_TO_STD[String(booked)]) booked = WBMRI_PROMO_TO_STD[String(booked)];   // 2026-10-13: a Promo booking stands in for its Standard

    if(booked === WBMRI_COMBO_VARIANT){
      // one line that already contains both the MRI and the baseline checkup
      want = want.filter(function(v){
        return Number(v) !== Number(BASES.wbmri.variant) && Number(v) !== Number(BASES.baseline.variant);
      });
    } else if(booked){
      var skipped=false;
      want = want.filter(function(v){
        if(!skipped && Number(v)===booked){ skipped=true; return false; }
        return true;
      });
    }
    return want.map(function(v){ return {id:v, quantity:1, properties:props}; });
  }

  function resetBuild(){
    /* If this literal changes, change the copy in sections/main-cart.liquid's
       "add another checkup" script with it — the two pages share no script, so the
       cleared object is written twice and has to stay byte-identical.
       sealedGid / committedBuild (2026-09-18) are the one tolerated difference: the
       cart page's copy does not carry them, and load() reads a missing key as null,
       so that copy clears the seal exactly as this one does. */
    state={ base:'baseline', upgrades:{}, addons:{}, date:null, slot:null, committedGid:null, committedSeq:null, sealedGid:null, committedBuild:null };
    /* Release the pinned group so the NEXT person legitimately opens a new one.
       Without this, "add another checkup" would keep reconciling into the group
       that is already complete and silently add nothing. Cleared in BOTH places:
       the module variable for this page, and the persisted copy for the next load —
       leaving the stored one behind is what would make person 2 adopt person 1's
       group and start adding to it. */
    COMMIT_SEQ = null;
    COMMIT_GID = null;
    SEALED_GID = null;
    save(state);
  }

  /* Commit the current build as one group, then either check out or start the next
     person. Both paths add to cart first — that is what makes "add another" safe. */
  /* Sentinel for "there is nothing to commit yet". Thrown rather than returned so it
     short-circuits the whole promise chain, and identity-checked in the catch so it
     never reaches the customer-facing error alert. */
  var ABORT = { himediAbort:true };
  /* Same shape as ABORT: not an error, but the run cannot continue and the
     customer has to be told. See purgeLegacy(). */
  var LEGACY = { himediLegacy:true };

  /* ---- ONE commit at a time, and ONE group per person --------------------
     DUPLICATE-CHECKUP BUG, 2026-08-11. One build was producing two complete
     checkups in the cart. Both halves below are required; either one alone
     still duplicates.

     The reconcile is idempotent WITHIN a group, and the auto-commit added on
     2026-08-10 was written on the assumption that this made it safe to run
     twice. It is not, because the two runs do not share a group.

     1. NOT SERIALIZED. autoCommit() guards itself with autoRunning, but
        commitCheckup is also called unguarded by the EAB checkout interceptor
        and by the [data-commit] panel buttons. reveal() shows that panel at the
        START of check(), before autoCommit resolves, so the customer is invited
        to click Checkout during the 1-3s the automatic pass is still in flight.
        That is the normal path, not an edge case.

     2. THE ALLOCATION RE-ALLOCATED. The second run called nextGroup() again. By
        then the first run had stamped the appointment line c1, so max=1 and the
        second run claimed c2 — an empty group. Its reconcile found the whole build
        "missing" and added every variant a second time. Idempotency is defeated by
        construction: the same build reconciled against a fresh group id can only
        ever add everything.
        (nextGroup() itself was deleted on 2026-08-27 — the group is minted at
        /cart/add time and there is nothing left to re-allocate here. The pin below
        is still required: it is what makes the second pass find the FIRST pass's
        group rather than no group at all.)

     Fix: queue every commit behind the previous one, and pin the group for this
     page session so a second pass converges on the group that already exists and
     finds nothing missing. resetBuild() clears the pin, which is what lets
     "add another checkup" legitimately open a new group.
  ------------------------------------------------------------------------- */
  /* The pinned group's SORT KEY, not its number — the ordinal stopped being data on
     2026-08-27, see the three-fields note at makeGid(). Carried so a pass that adds
     lines to the pinned group stamps them with the same _cseq the group already has. */
  var COMMIT_SEQ = state.committedSeq || null;
  /* The full key, e.g. "g-qkzfhxmpwr". The `'c'+committedGroup` fallback is for a
     cart that was already in flight before 2026-08-24: its lines carry the old
     suffix-free ids, and without it those customers would stop recognising their own
     appointment and be told to book again. committedGroup is never written any more,
     so this reconstruction is read-only and dies with the last such cart. */
  var COMMIT_GID = state.committedGid ||
                   ((typeof state.committedGroup === 'number') ? 'c'+state.committedGroup : null);
  /* ---- SEALED GROUP (2026-09-18) ----------------------------------------------
     The pin survives the trip to checkout on purpose: a customer who taps back
     from checkout must still see the held box with Checkout / Add another checkup,
     not be made to book again. But the pin is also what a page load reconciles
     INTO, so checkout → back → change the build → summary was reconciling the
     CHANGED build into the group that had already been handed off: the add-on
     landed in Checkup 1 before any second booking, and the second booking then
     minted group 2 and added it again (reproduced live, repro-base.mjs).

     The rule: a handed-off group is sealed. Pressing Checkout seals the pinned
     group before navigating; while the pin is sealed, check() reveals the box but
     does not auto-commit, and runCommit reconciles nothing — it renumbers and
     navigates. Everything that mints or releases the pin clears the seal, so a new
     appointment still opens a fresh, unsealed group exactly as before. The seal is
     keyed to the group, not merely a flag, so a stale seal can never stick to a
     group it was not written for. */
  var SEALED_GID = state.sealedGid || null;
  function pinSealed(){ return COMMIT_GID != null && SEALED_GID === COMMIT_GID; }
  /* A short fingerprint of what this build would put in a group — the base route
     and the variant list wantFor() reconciles from. Stored at seal time; compared
     on a later load so the box can say the cart was left as it was. djb2 → base36,
     kept small because it lives in localStorage beside the pin. */
  function buildHash(){
    var s = baseKey() + ':' + desiredVariants().map(String).sort().join(',');
    var h = 5381, i;
    for(i=0;i<s.length;i++){ h = ((h * 33) ^ s.charCodeAt(i)) >>> 0; }
    return h.toString(36);
  }
  /* Set by wireEabMode(). The /cart/add interceptor calls it whenever it mints a
     group for a NEW appointment, so a second booking made in one page session gets
     its own reconcile pass instead of being stranded behind autoDone's one-way
     latch with its add-ons never added.
     This is safe ONLY because positional claiming is gone. The same re-arm was
     tried on 2026-08-26 while stampUntagged() was still in place and it made things
     worse: the re-armed pass stamped the second booking into the FIRST person's
     group. A pass can now only reconcile the pinned group, which the interceptor
     just minted for this very booking, and it cannot touch any other line. */
  var REARM = null;
  var commitQueue = Promise.resolve();
  function commitCheckup(mode, btn){
    var run = function(){ return runCommit(mode, btn); };
    // .then(run, run) so a rejected earlier commit still lets the next one start
    var p = commitQueue.then(run, run);
    commitQueue = p.catch(function(){});
    return p;
  }

  function runCommit(mode, btn){
    var label = btn ? btn.textContent : '';
    if(btn){ btn.disabled=true; btn.textContent = mode==='checkout' ? 'Starting checkout…' : 'Saving this checkup…'; }
    // Every step is traced. A commit that stalls used to look like a dead button with
    // no way to tell which step died; window.HIMEDI_COMMIT keeps the trace for support.
    var trace = { mode:mode, t0:Date.now(), steps:[] };
    window.HIMEDI_COMMIT = trace;
    var note = function(s, extra){
      trace.steps.push({ step:s, ms:Date.now()-trace.t0, info:extra });
      try{ console.log('[himedi commit]', s, extra===undefined?'':extra); }catch(_){}
    };
    var release = function(){ if(btn){ btn.disabled=false; btn.textContent=label; } };
    // If nothing has navigated in 12s the promise chain is wedged — give the button
    // back rather than leaving the customer staring at "Starting checkout…".
    var stalled = setTimeout(function(){
      if(trace.done) return;
      note('STALLED');
      release();
      alert('That took too long. Your appointment is saved — press Checkout again, or open your cart to continue.');
    }, 12000);

    /* ---- RECONCILE, don't predict -------------------------------------
       The old path guessed which line the booking app had created
       (pendingBooking), subtracted that one variant from the wanted set, added
       the rest and never checked the result. Every observed failure came from
       that guess being wrong:
         guess returns null            -> nothing subtracted -> duplicate focus area
         guess returns a stale line    -> wrong variant subtracted -> missing baseline
         EAB line merged / no props    -> invisible to the guess -> group short

       This version does the opposite. It stamps the group FIRST, re-reads the
       cart, then compares what the group actually contains against what it
       should contain and adds only the difference. It does not care which
       variant EAB attached the appointment to, whether the line merged, or
       whether it carried properties — it converges on the correct group either
       way, and it is safe to run twice.
    ------------------------------------------------------------------- */
    note('start');
    var own, props, sealed = false;
    return getCart().then(function(cart){
      note('cart read', { lines:(cart.items||[]).length });
      /* Before ANY gate reads the cart. A legacy group answers every question
         below wrongly -- it holds a date, it holds a booking line, and it holds
         variants this build will happily add a second checkup alongside. */
      return purgeLegacy(cart, note);
    }).then(function(cart){

      /* ---- a booking is a precondition, not an assumption -------------------
         The reconcile below adds every wanted variant the group does not already
         have. On the summary page that is only correct AFTER EAB has created the
         appointment line. It used to run regardless: with an empty cart the whole
         build counted as "missing", so it was added carrying nothing but
         Checkup/_cgid — no Date, no Time, no _Event #. The customer then checked
         out and the Korea team received an order with no date. That is orders
         #3104, #3105, #3110 and #3113, and it is reachable simply by opening the
         cart icon on step 3 without picking a date.
         Nothing is added to the cart until an appointment exists. */
      /* Not hasBooking — another person's stamped appointment must not authorise
         adding THIS build. Not merely "a line the app touched" either: an
         appointment with no date is not an appointment. (2026-08-11, 2026-08-24)
         pinnedDatedBooking, not the old ownBooking — see the note on it. "Ours" is now the
         group the /cart/add interceptor minted for this booking, not "whatever is
         untagged". (2026-08-27) */
      if(eabMode() && !pinnedDatedBooking(cart)){
        note('ABORT — no dated booking for this build');
        throw ABORT;
      }

      /* ---- SEALED: handed off already, so nothing is reconciled (2026-09-18) ---
         The dated booking is still required above — a box over a group with no
         appointment is not a box that may check out. Past that gate a sealed group
         is left exactly as it is: no allocation, no add, no verify. The renumber
         still runs (labels are cosmetic and cheap to correct) and the mode's
         navigation still happens, so Checkout pressed a second time reaches
         checkout with the same lines and 'another' still starts the next person.
         pinIsStale() is deliberately NOT consulted first: a changed build must not
         release the pin either, or the box would vanish behind the customer. */
      if(pinSealed()){
        sealed = true;
        note('sealed', COMMIT_GID + ' — handed off already; nothing added');
        return;
      }
      /* Pin the group for this page session, AFTER the booking gate above. A second
         commit reuses the pin and its reconcile finds nothing missing — which is the
         whole point. Re-deriving a group here is what produced the duplicate
         checkup; nothing derives one here any more. */
      if(pinIsStale(cart)){
        note('group', 'pin ' + COMMIT_GID + ' belongs to a different checkup - opening a new group');
        COMMIT_SEQ = null; COMMIT_GID = null;
        SEALED_GID = null; state.sealedGid = null; state.committedBuild = null;
      }
      /* ---- in app mode there is nothing to allocate here (2026-08-27) --------
         The group was minted by the /cart/add interceptor, on the request that
         carried the appointment, and the gate above has already proved that pinned
         group holds a dated booking line. Allocating one HERE is what made the
         merge possible: a freshly minted empty group could only be filled by
         claiming somebody's untagged line, and that claim had no ownership test.
         With no pin there is simply no group of ours in this cart. Inventing one
         would produce an empty, dateless group and nothing could ever legitimately
         land in it, so stop instead. */
      if(eabMode()){
        if(COMMIT_GID == null){ note('ABORT — no group for this build'); throw ABORT; }
        /* The label and the sort key are READ off the group the interceptor already
           created, never re-derived here, so every line this pass adds agrees with
           the booking line it is joining and canonicaliseLabels() at the end of the
           run has one label per group to correct rather than a mixture. */
        own = groupFields(cart, COMMIT_GID);
        if(own.seq) COMMIT_SEQ = own.seq;
        props = {}; props[GLABEL]=own.label; props[GKEY]=COMMIT_GID; props[VKEY]=CART_SCHEMA;
        if(COMMIT_SEQ) props[SKEY]=COMMIT_SEQ;
        note('group', COMMIT_GID + ' (minted at add time)');
        return;
      }
      /* Placeholder-calendar mode: no booking app, so no intercepted add to stamp.
         This path adds every wanted variant itself, carrying props, so the group is
         still created by the same request that creates the lines. */
      var reused = (COMMIT_GID != null);
      var gid = reused ? COMMIT_GID : makeGid();
      if(!reused) COMMIT_SEQ = String(Date.now());
      COMMIT_GID = gid;
      own = groupFields(cart, gid);
      if(own.seq) COMMIT_SEQ = own.seq;
      props = {}; props[GLABEL]=own.label; props[GKEY]=gid; props[VKEY]=CART_SCHEMA;
      if(COMMIT_SEQ) props[SKEY]=COMMIT_SEQ;
      note('group', gid+(reused?' (pinned)':' (new)'));
    }).then(function(){
      return sealed ? null : getCart();
    }).then(function(cart){
      if(sealed) return;
      /* ---- the appointment is a precondition of the ADD, not just of the run ----
         2026-08-24. The gate at the top of this chain asks whether an appointment
         exists in the CART. This one asks the only question that actually matters:
         does the group we are about to add into hold one? They come apart whenever
         the stamp did not land where it was expected, or the cart read that decided
         it was stale — and when they do, `have` comes back empty, the whole build
         counts as missing, and every line of it is added carrying nothing but
         Checkup/_cgid. That is the dateless-order signature (#3104/#3105/#3110/
         #3113) and the duplicate half of #3208.

         Gabe's rule, verbatim: nothing is added to the cart throughout the process
         until the date check is passed. This is where that is enforced. If the group
         has no date, nothing is added at all — not the base, not the focus areas,
         not the add-ons — and the customer is told to pick a date.

         Note what is NOT done here: base variants are not banned outright. Orders
         #3205 and #3212 show why. An EAB event can only own a variant once, so the
         Brain and Cancer events are bound to the focus-area products, EAB creates
         the DATED focus-area line, and the theme fills the $299 Baseline in behind
         it. The Baseline line in those orders carries no date and is correct: the
         appointment lives on exactly one line per group and the group has one.
         Refusing to add a base would make every Brain and Cancer build unbuyable.
         The rule enforced is the real one — a group must hold an appointment before
         it holds anything else. */
      var have=[];
      (cart.items||[]).forEach(function(it){
        if((it.properties||{})[GKEY] !== props[GKEY]) return;
        for(var i=0;i<(it.quantity||1);i++) have.push(Number(it.variant_id));
      });
      var dates = groupDates(cart, props[GKEY]);
      note('appointment', { group:props[GKEY], dates:dates, have:have });
      if(eabMode() && !dates.length){
        note('ABORT — group holds no appointment date, nothing added');
        throw ABORT;
      }
      /* Two different dates under one group key is the collision this file used to
         produce (#3208: two checkups both stamped c1). It is unambiguous corruption —
         nobody can tell which line belongs to which appointment — so stop rather than
         add more lines into it. */
      if(dates.length > 1){
        note('BLOCKED — two appointments share this group', dates);
        try{ console.error('[himedi commit] group', props[GKEY], 'holds two appointment dates:', dates); }catch(_){}
        throw new Error('Two different appointments got filed under one checkup. Please open your cart and remove one before paying, or contact us and we will fix it.');
      }

      var want = wantFor(have);
      var d = diff(have, want);
      var missing = d.missing;
      note('reconcile', { have:have, want:want, missing:missing, extra:d.extra });
      if(!missing.length){ note('nothing missing'); return; }
      /* A group holds one checkup. The only build that legitimately wants two base
         lines is the MRI + Baseline pair when the booking app added them separately
         instead of as the combo, and wantFor() already says so. Anything beyond what
         the build asks for is a double charge, so it is surfaced rather than added. */
      var haveBases = have.filter(isBaseVariant).length;
      var addBases  = missing.filter(isBaseVariant).length;
      var wantBases = want.filter(isBaseVariant).length;
      if(haveBases + addBases > wantBases){
        note('BLOCKED — that would leave ' + (haveBases+addBases) + ' checkup lines in a group that wants ' + wantBases);
        try{ console.error('[himedi commit] refusing to over-add a checkup line', {have:have, want:want, missing:missing}); }catch(_){}
        throw new Error('Something looks wrong with this checkup — it would be charged twice. Please open your cart and check it before paying.');
      }
      var items = missing.map(function(v){ return {id:v, quantity:1, properties:props}; });
      return postJSON('/cart/add.js',{items:items}).then(function(){ note('added', missing); });
    }).then(function(){
      if(sealed) return;
      // final check — if the group is still short, say so loudly rather than
      // letting someone reach checkout with a half-built checkup
      return getCart().then(function(cart){
        var have=[];
        (cart.items||[]).forEach(function(it){
          if((it.properties||{})[GKEY] !== props[GKEY]) return;
          for(var i=0;i<(it.quantity||1);i++) have.push(Number(it.variant_id));
        });
        var want = wantFor(have);
        var d = diff(have, want);
        var short = d.missing, extra = d.extra;
        var dates = groupDates(cart, props[GKEY]);
        note('verify', { group:props[GKEY], have:have, want:want, short:short, extra:extra, dates:dates });

        // the appointment must still be there when we hand the customer to checkout
        if(eabMode() && !dates.length){
          try{ console.error('[himedi commit] group', props[GKEY], 'reached verify with no appointment date'); }catch(_){}
          throw new Error('This checkup has no appointment date. Please choose a date and time before paying.');
        }
        if(dates.length > 1){
          try{ console.error('[himedi commit] group', props[GKEY], 'holds two appointment dates:', dates); }catch(_){}
          throw new Error('Two different appointments got filed under one checkup. Please open your cart and remove one before paying, or contact us and we will fix it.');
        }
        if(short.length) throw new Error('Your checkup did not save completely. Please open your cart and check before paying.');

        /* ---- over-add check (2026-08-24) --------------------------------
           This step only ever computed what the group was SHORT of. A group that
           ended up with MORE than the build called for sailed through — which is
           how #3208 reached checkout carrying a second $1,799 MRI line and a
           second $299 Baseline. Extra CHECKUP lines are a double charge and stop
           the customer here. Extra non-base lines are logged loudly but do not
           block: the booking app is entitled to put its own line into the cart
           and refusing to let a customer pay over one would be worse. */
        var extraBases = extra.filter(isBaseVariant);
        if(extraBases.length){
          try{ console.error('[himedi commit] group', props[GKEY], 'holds unexpected extra checkup lines:', extraBases, {have:have, want:want}); }catch(_){}
          throw new Error('This checkup has duplicate lines in your cart and would be over-charged. Please open your cart and remove the extras before paying.');
        }
        if(extra.length){
          note('EXTRA non-base lines in group', extra);
          try{ console.warn('[himedi commit] group', props[GKEY], 'holds lines this build did not ask for:', extra); }catch(_){}
        }
      });
    }).then(function(){
      trace.done = true; clearTimeout(stalled);
      /* Persist the group so a reload re-adopts it rather than presenting as a new
         person with no booking. resetBuild() clears it when a new person starts. */
      state.committedSeq = COMMIT_SEQ; state.committedGid = COMMIT_GID; save(state);
      /* ---- SITE 1 OF 3: RENUMBER, LAST STEP OF A SUCCESSFUL COMMIT ----------
         A group was just minted or filled, so this is the moment the numbering can
         be wrong. It runs HERE, before any navigation, because the order is a
         snapshot of the cart at checkout: the labels are right on the order, the
         packing slip and the email if and only if they were right in the cart at
         that instant. Already inside commitQueue, so it cannot interleave with
         another commit. It is a no-op on a cart that is already correct.
         Its failure is caught and NOT rethrown on purpose. The numbering is
         cosmetic; the booking is not. A customer whose cart is complete must not be
         stopped at checkout because a label write failed — window.HIMEDI_RENUMBER
         and the trace record it, and the next cart-page load re-canonicalises.
         (Sites 2 and 3 are in sections/main-cart.liquid. GROUPING-STATE-MACHINE
         §5.5.4 lists a fourth, in the cart drawer; it does not exist here because
         the drawer is disabled in this theme. The three measurements that say so,
         and the instruction to re-measure rather than assume, are in the Liquid
         comment above main-cart.liquid's HimediRenumber block — deliberately in
         Liquid, so the drawer's element name is not shipped in prose and cannot
         answer a grep of the rendered page as if the element were present.) */
      note('renumber');
      return canonicaliseLabels().then(
        function(r){ note('renumbered', r); },
        function(e){
          note('renumber FAILED', (e && e.message) || String(e));
          try{ console.error('[himedi commit] renumber failed; labels may be stale', e); }catch(_){}
        });
    }).then(function(){
      /* 'stay' runs automatically the moment the booking app adds its line, so the
         group is complete before the customer can go anywhere. It must not navigate
         and must not reset the build — the commit panel still needs the selections. */
      if(mode==='stay'){ note('reconciled in place'); return; }
      note('navigating');
      if(mode==='checkout'){
        /* SEAL before leaving. From here on the group belongs to the checkout the
           customer is being sent to; a back button, a reload or a second tab may
           still show the box over it but may not change it. The build fingerprint
           travels with the seal so a later load can say whether the cart still
           matches what the customer has since edited. Idempotent on a second press. */
        if(!sealed){
          SEALED_GID = COMMIT_GID; state.sealedGid = COMMIT_GID; state.committedBuild = buildHash(); save(state);
          note('sealed', COMMIT_GID);
        }
        window.location.href='/checkout'; return;
      }
      /* 2026-10-14: 'same' = the next person gets this person's checkup (base, focus areas, add-ons) and goes
         straight to the calendar. Everything else about starting a new person is resetBuild(), unchanged. */
      var keep = mode==='same' ? JSON.parse(JSON.stringify({ base:state.base, upgrades:state.upgrades||{}, addons:state.addons||{} })) : null;
      resetBuild();
      if(keep){ state.base=keep.base; state.upgrades=keep.upgrades; state.addons=keep.addons; save(state); window.location.href='/pages/checkup-summary'; return; }
      var slot=$('.cf-commit'); var url=(slot && slot.getAttribute('data-another-url')) || '/pages/checkup-build';
      window.location.href=url;
    }).catch(function(e){
      trace.done = true; clearTimeout(stalled);
      /* The cart was built by the old model and has been cleared. Said out loud even
         on an automatic pass -- the customer's cart just changed under them, and
         silence would send them to a checkout that no longer holds their booking. */
      if(e === LEGACY){
        trace.legacy = true;
        note('legacy cart cleared');
        release();
        alert('We have updated how checkups are sold, so the older items in your cart were cleared. Nothing has been charged. Please pick your checkup and choose a date again.');
        return;
      }
      /* Not an error: the customer has not booked yet. Say so plainly if they asked
         for this explicitly, and stay silent if it was an automatic pass. */
      if(e === ABORT){
        trace.aborted = true;
        note('aborted — nothing added');
        release();
        if(mode !== 'stay'){
          alert('Please choose a date and time for your checkup first — then your selections are added to the cart together.');
        }
        return;
      }
      trace.error = (e && (e.message||String(e))) || 'error';
      note('FAILED', trace.error);
      release();
      /* An automatic pass must never pop an alert the customer did not ask for.
         It stays silent; the explicit button press will surface any real problem. */
      if(mode==='stay') return;
      alert('Could not save this checkup: ' + trace.error + '\n\nYour appointment is still held. You can open your cart to continue.');
    });
  }

  /* ---- EAB booking-app mode (summary page) ----
     EAB's inline calendar owns the appointment: choosing a time and pressing its
     "Add to Cart" creates the base line with the real booking attached. We take over
     from there so the focus areas and add-ons land in the same group, and so EAB's
     own Checkout cannot leave with an untagged cart. */
  /* ---- WBMRI: make the booking app add the RIGHT variant ----------------
     The Whole Body MRI product has two variants: MRI only ($1,700) and
     MRI + Checkup ($1,999). One EAB event covers both (its `variants` array
     lists them), but on a page whose path is not /products/ the app falls back
     to the event's default variant — the MRI-only one — so selecting Checkup
     produced two cart lines instead of one combo line.

     Setting window.Servicify.currentActiveVariantId is not reliable: the widget
     assigns it in its own onAfterOpen and nulls it on close, so it races us.
     Instead we rewrite the request at the point it is made. Deterministic, and
     it does not depend on the app's internals staying the same.

     Only the variant id is rewritten — the appointment's Date / Time / _Event #
     travel as line-item properties on the same line and are left untouched, so
     the booking still lands intact. buildItems() then sees the combo variant as
     `booked` and adds nothing further. */
  function wireWbmriVariantSwap(){
    var WB_ONLY = Number(BASES.wbmri.variant);        // 56900675829926
    var WB_COMBO = Number(WBMRI_COMBO_VARIANT);       // 56900675928230
    function wantsCombo(){
      var s = load();
      return s.base === 'wbmri' && !!(s.upgrades && s.upgrades.checkup);
    }
    function swap(id){ return Number(id) === WB_ONLY && wantsCombo() ? WB_COMBO : id; }
    /* ---- WBMRI PROMO SUBSTITUTION (2026-09-28) ------------------
       Mirrors rewriteCheckupItem below exactly, one step later: it runs AFTER the
       WB_ONLY -> WB_COMBO swap above has settled which of the two WBMRI variants
       this booking is, then swaps THAT variant to its Promo twin if the appointment
       date is in the ended promo's window. Deliberately does not reuse isPromoWindowProps
       before PROMO_SWITCH_MS: before the switch this must be a no-op (today's
       WBMRI booking flow is unchanged), whereas isPromoWindowProps alone would answer
       the OLD Sep-Dec 2026 question, which is the wrong question for a variant that
       does not exist as a live discount target until ended promo starts. */
    function rewriteWbmriPromo(it){
      if(!WBMRI_PROMO_GATE) return false;   // gate off: WBMRI behaves exactly like today's live code
      if(!it || it.id == null) return false;
      if(promoNowMs() < PROMO_SWITCH_MS) return false;
      var id = Number(it.id);
      var promo = WBMRI_STD_TO_PROMO[String(id)];
      if(!promo) return false;
      if(!isPromoWindowProps(it.properties)) return false;
      it.id = Number(promo);
      return true;
    }
    /* ---- THE SEPTEMBER SUBSTITUTION (2026-08-26) -------------------------
       The date page's calendar is bound to ONE variant of the Checkup product, so
       EAB adds that same variant whatever the customer actually built. Two things
       therefore have to be corrected in the outgoing /cart/add body, and this is
       the only moment both facts exist together: the chosen appointment date sits
       in items[].properties.Date in the SAME request that carries items[].id.

         1. swap to the variant for the combination the customer built, and
         2. swap to that combination's SEPTEMBER twin when the date they just
            picked falls in September 2026.

       ONLY items[].id is touched. Date / Time / _Event # / _Start Date travel as
       line properties on the same line and are left exactly as EAB wrote them --
       which is what keeps the booking intact. Doing this after the line exists is
       NOT equivalent: /cart/change.js cannot change a variant id, so the only
       alternative is remove-and-re-add, and that is what produced the dateless
       orders #3104/#3105/#3110/#3113. It happens here or not at all.

       All 16 variants are attached to EAB event 130604, so whichever one we land
       on is inside that event's variants array and the booking still resolves. */
    function rewriteCheckupItem(it){
      if(!it || it.id == null) return false;
      var id = Number(it.id);
      if(ALL_COMBO_VARIANTS.indexOf(id) === -1) return false;   // not a Checkup line
      var want = comboVariant(isSeptemberProps(it.properties));
      if(!want || Number(want) === id) return false;
      /* Plain Baseline (no focus area) never qualifies for the promo unless Gabe flips
         INCLUDE_PLAIN_BASELINE_PROMO -- but ONLY post-switch. Pre-switch this must stay
         a no-op: today's LIVE code already swaps plain Baseline to its September twin
         same as every other combination, and that behaviour is contracted (by every
         comment in this file) to be byte-for-byte unchanged before the switch. Refuses
         only the GRANTING direction (Standard -> Promo); a stray Promo line downgrading
         back to Standard is still allowed through, same "only tighten" rule as
         reconcileStalePromos(). */
      if(promoNowMs() >= PROMO_SWITCH_MS && comboKey() === 'base' &&
         !INCLUDE_PLAIN_BASELINE_PROMO && Number(want) === COMBO_VARIANTS.base.sep){
        return false;
      }
      it.id = Number(want);
      try{
        window.HIMEDI_SEP_SWAP = { from:id, to:Number(want),
          september: STD_TO_SEP[String(want)] === undefined, at:Date.now() };
      }catch(_){}
      return true;
    }

    /* ---- STAMP THE GROUP ONTO THE BOOKING'S OWN ADD (2026-08-27) -----------
       This is the keystone of the grouping fix. The booking app posts its
       appointment to /cart/add.js through axios, whose browser adapter is
       XMLHttpRequest, so the patch below sees the body BEFORE the line exists.
       Writing _cgid here means the line is born owned: no later pass has to guess
       which line belongs to whom, and stampUntagged() — which guessed positionally
       and merged two people under one header — is gone. See mintGroupForAdd().

       WHAT IS STAMPED, AND ONLY THIS. A request is an appointment add if one of
       its items carries a date property. That is the same test every gate in this
       file already uses (lineDate/DATE_KEYS), and it is deliberately the test
       rather than "is this a checkup variant":
         * a brochure, or anything else on the site, carries no date and is left
           completely alone — it stays ungrouped, as it should;
         * a checkup added with NO date is left alone too. Gabe's rule is that
           nothing is added to the cart until the date check passes, and stamping a
           dateless checkup would manufacture exactly the dateless group that rule
           exists to prevent. It shows up under "Other items", visibly.
       Every item in an appointment request gets the same group — the booking line
       and any extras the app appends to the same call belong together.

       ONE DATED ADD, ONE GROUP. A fresh key is minted per request, so two bookings
       — same page, two tabs, or minutes apart — cannot land in one group. The old
       code CHECKED for two dates in a group after the fact and threw; the throw was
       swallowed on the automatic pass. This makes the state unconstructible instead.

       Our own adds are never stamped twice: postJSON marks them __himediInternal so
       the fetch wrapper skips this entirely, and the reconcile's items already carry
       _cgid, which the `already` test below refuses to overwrite. */
    function stampBookingAdd(o){
      var items = Array.isArray(o && o.items) ? o.items
                : (o && o.id != null ? [o] : []);
      if(!items.length) return false;
      var dated = items.some(function(it){ return !!lineDate(it); });
      if(!dated) return false;                                     // not an appointment
      // already owned — the reconcile's own add, or a body we have seen before
      if(items.some(function(it){ return it && it.properties && it.properties[GKEY]; })) return false;
      var mint = mintGroupForAdd();
      /* _cseq is the group's position and is minted with it. The Checkup label is a
         provisional rank off the last cart we read — display only, corrected by
         canonicaliseLabels() at the end of this booking's commit. Every line of the
         request gets the identical three values, so the group is internally
         consistent from the instant it exists. */
      var label = 'Checkup ' + provisionalRank();
      items.forEach(function(it){
        if(!it.properties) it.properties = {};
        it.properties[GLABEL] = label;
        it.properties[GKEY]   = mint.gid;
        it.properties[SKEY]   = mint.seq;
        it.properties[VKEY]   = CART_SCHEMA;
      });
      try{ window.HIMEDI_ADD_STAMP = { gid:mint.gid, seq:mint.seq, label:label, lines:items.length, at:Date.now() }; }catch(_){}
      try{ console.log('[himedi] appointment add stamped into group', mint.gid); }catch(_){}
      /* A new appointment means a new group to reconcile, so re-open the automatic
         pass. Only reachable once the mint above has repointed the pin at THIS
         booking — see the note on REARM. */
      if(REARM){ try{ REARM(); }catch(_){} }
      return true;
    }

    function rewrite(body){
      try{
        var o = typeof body === 'string' ? JSON.parse(body) : body;
        var hit = false, comboHit = false, promoHit = false;
        if(o && o.id && Number(o.id) === WB_ONLY && wantsCombo()){ o.id = WB_COMBO; hit = true; comboHit = true; }
        if(o && o.id != null && !Array.isArray(o.items)){
          if(rewriteCheckupItem(o)) hit = true;
          if(rewriteWbmriPromo(o)){ hit = true; promoHit = true; }
        }
        if(o && Array.isArray(o.items)){
          o.items.forEach(function(it){
            if(it && Number(it.id) === WB_ONLY && wantsCombo()){ it.id = WB_COMBO; hit = true; comboHit = true; }
            if(rewriteCheckupItem(it)) hit = true;
            if(rewriteWbmriPromo(it)){ hit = true; promoHit = true; }
          });
        }
        /* Kept out of `hit` on purpose: `hit` also drives the WBMRI log line below,
           and a plain September booking is not a WBMRI swap. */
        var stamped = stampBookingAdd(o);
        if(!hit && !stamped) return null;
        if(comboHit){
          window.HIMEDI_WB_SWAP = { from:WB_ONLY, to:WB_COMBO, at:Date.now() };
          try{ console.log('[himedi] WBMRI variant swapped to the MRI + Checkup combo'); }catch(_){}
        }
        if(promoHit){
          window.HIMEDI_WB_PROMO_SWAP = { at:Date.now() };
          try{ console.log('[himedi] WBMRI variant swapped to its Promo twin'); }catch(_){}
        }
        return JSON.stringify(o);
      }catch(e){ return null; }
    }

    var origFetch = window.fetch;
    if(origFetch && !origFetch.__himediWb){
      var wrapped = function(input, init){
        try{
          /* Scope: rewrite ONLY adds that come from the product-form / booking-app
             path. postJSON marks every request this file makes, and they are passed
             straight through — the reconcile asks for exactly the variants it means
             and must never have them swapped underneath it. Order #3208's extra
             $1,799 combo line came from this wrapper catching our own add.
             (2026-08-24) */
          if(init && init.__himediInternal) return origFetch.call(this, input, init);
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if(/\/cart\/add(\.js)?/.test(url) && init && init.body){
            var nb = rewrite(init.body);
            if(nb){ init = Object.assign({}, init, { body: nb }); }
          }
        }catch(e){}
        return origFetch.call(this, input, init);
      };
      wrapped.__himediWb = true;
      window.fetch = wrapped;
    }

    var origSend = XMLHttpRequest.prototype.send;
    var origOpen = XMLHttpRequest.prototype.open;
    if(!origSend.__himediWb){
      XMLHttpRequest.prototype.open = function(m, u){
        this.__himediUrl = u;
        return origOpen.apply(this, arguments);
      };
      var s = function(body){
        try{
          if(/\/cart\/add(\.js)?/.test(this.__himediUrl || '') && body){
            var nb = rewrite(body);
            if(nb) body = nb;
          }
        }catch(e){}
        return origSend.call(this, body);
      };
      s.__himediWb = true;
      XMLHttpRequest.prototype.send = s;
    }
  }

  // wrapped immediately: a late wrap loses to any app that cached window.fetch
  try{ wireWbmriVariantSwap(); }catch(e){}

  /* ---- STALE PROMO REWIND (2026-09-28, ended promo swap) ---------------------
     MEASURED LEAK: a cart line minted as a Promo twin (a Checkup 'sep' variant, or a
     WBMRI Promo variant) before PROMO_SWITCH_MS, for an appointment date that is
     NOT in the window active right now, is never re-examined by anything on page
     load -- only the /cart/add interceptor above ever decides Standard vs Promo, and
     it only runs at add time. Reproduced 2026-09-28: add Baseline+Heart at a
     BEFORE-switch time for a Nov 2026 appointment (today's live behaviour puts it on
     the Promo twin, correctly), then reload the builder or summary page at an
     AFTER-switch time -- the Promo variant sat in the cart unchanged. Shopify's promo
     discount is scoped by variant id, not by appointment date, so that stale
     line would carry the ended promo price to checkout for a booking that no longer
     qualifies under the new window.

     This only TIGHTENS: it downgrades a Promo line whose date no longer qualifies
     back to Standard. It never upgrades a Standard line to Promo -- that direction
     stays owned entirely by the add-time interceptor, and granting an unrequested
     discount is the wrong direction to fail in (same principle as
     isPromoWindowProps: "a missing or unreadable value is NOT in the window --
     withhold, never grant").

     Uses postJSON (marked __himediInternal), so the re-add below is NOT re-examined
     by the interceptor -- the Standard id decided here is final by construction, not
     subject to being swapped back. Properties (_cgid/_cseq/Checkup/_cv, Date, Time,
     etc.) are carried over BYTE FOR BYTE, so group identity, order and label all
     survive exactly the way purgeLegacy() already carries them across a remove +
     re-add. Never touches a line that is not a known Promo variant, and never touches
     more lines than are actually stale. */
  /* Gate-aware on purpose: when a variant is excluded here, reconcileStalePromos()
     treats it as "not a known Promo variant" and leaves it alone entirely -- see the
     flags' own comment above WBMRI_PROMO_GATE/INCLUDE_PLAIN_BASELINE_PROMO. */
  var SEP_TO_STD = (function(){
    var m = {};
    Object.keys(COMBO_VARIANTS).forEach(function(k){
      if(k === 'base' && !INCLUDE_PLAIN_BASELINE_PROMO) return; // flag off: never touch plain Baseline
      m[String(COMBO_VARIANTS[k].sep)] = COMBO_VARIANTS[k].std;
    });
    return m;
  })();
  var WBMRI_PROMO_TO_STD = (function(){
    if(!WBMRI_PROMO_GATE) return {};   // gate off: never touch a WBMRI line
    var m = {};
    Object.keys(WBMRI_STD_TO_PROMO).forEach(function(std){
      m[String(WBMRI_STD_TO_PROMO[std])] = Number(std);
    });
    return m;
  })();
  function reconcileStalePromos(){
    return getCart().then(function(cart){
      var stale = (cart.items||[]).filter(function(it){
        var id = String(it.variant_id);
        var downgradeTo = SEP_TO_STD[id] || WBMRI_PROMO_TO_STD[id];
        if(!downgradeTo) return false;          // not a Promo variant -- nothing to reconsider
        return !isPromoWindowProps(it.properties); // still qualifies -- leave it alone
      });
      if(!stale.length) return;
      var removeUpdates = {};
      stale.forEach(function(it){ if(it.key) removeUpdates[it.key] = 0; });
      return postJSON('/cart/update.js', { updates:removeUpdates }).then(function(){
        var adds = stale.map(function(it){
          var id = String(it.variant_id);
          var stdId = SEP_TO_STD[id] || WBMRI_PROMO_TO_STD[id];
          return { id:stdId, quantity:it.quantity, properties:it.properties };
        });
        return postJSON('/cart/add.js', { items:adds });
      }).then(function(){
        try{ window.HIMEDI_STALE_PROMO_REWIND = { count:stale.length, at:Date.now() }; }catch(_){}
      });
    }).catch(function(e){ try{ console.error('[himedi] stale promo reconcile failed', e); }catch(_){} });
  }

  function wireEabMode(){
    var slot=$('.cf-app-slot'); if(!slot) return;
    var panel=$('.cf-commit');

    var hideEabDupes=function(){
      // one checkup = one booking; starting a second one goes through our own button
      $$('button, a').forEach(function(b){ if(/book another appointment/i.test(b.textContent||'')) b.style.display='none'; });
      // EAB also renders its own Checkout once the appointment is in the cart, sitting
      // right above ours — two checkout buttons on the last screen before payment.
      // Ours is the one that must survive: it commits the focus areas and add-ons into
      // the same group and offers "Add another checkup". EAB's is the duplicate, so it
      // is hidden here. Scoped to .cf-app-slot so our own panel button is never caught.
      // Hidden rather than removed — the capture-phase interceptor below still routes
      // it correctly if the app re-renders it before this runs.
      $$('.cf-app-slot a, .cf-app-slot button').forEach(function(b){
        var txt=(b.textContent||'').trim().toLowerCase();
        if(/^check\s?out$/.test(txt) || /proceed to checkout/.test(txt)) b.style.display='none';
      });
    };
    hideEabDupes();
    if('MutationObserver' in window){
      new MutationObserver(hideEabDupes).observe(document.body,{childList:true,subtree:true});
    }

    function reveal(){
      if(!panel || !panel.hidden) return;
      panel.hidden=false;
      panel.setAttribute('tabindex','-1');
      panel.focus({preventScroll:true});
      panel.scrollIntoView({behavior:'smooth', block:'nearest'});
    }
    /* ---- the box over a sealed group (2026-09-18) --------------------------------
       Same box, same two buttons — Checkout goes on with the group as it is and
       "Add another checkup" starts the next person as before. What changes is what
       the box does NOT do: it never reconciles the current build into the sealed
       group. If the customer has edited the build since handing it off, the cart no
       longer matches what the page shows, so the box says so in one sentence. The
       attributes are for the section's CSS and for the flow tests. Cleared again
       the moment the pin moves to a new, unsealed group. */
    var SEALED_COPY = 'Your booked checkup is in your cart as it was; open the cart to change it, or add another checkup for someone else.';
    function markSealed(){
      if(!panel) return;
      panel.setAttribute('data-sealed','1');
      var changed = !!(state.committedBuild && state.committedBuild !== buildHash());
      if(!changed || panel.getAttribute('data-sealed-changed') === '1') return;
      panel.setAttribute('data-sealed-changed','1');
      var p = $('.cf-commit-p', panel);
      if(p){
        var s = document.createElement('span');
        s.setAttribute('data-sealed-note','');
        s.textContent = ' ' + SEALED_COPY;
        p.appendChild(s);
      }
      try{ console.log('[himedi] sealed group', COMMIT_GID, 'build changed since checkout; cart left as it was'); }catch(_){}
    }
    function clearSealed(){
      if(!panel) return;
      panel.removeAttribute('data-sealed'); panel.removeAttribute('data-sealed-changed');
      var n = $('[data-sealed-note]', panel); if(n && n.parentNode) n.parentNode.removeChild(n);
    }
    /* ---- close the window between "booked" and "committed" -------------
       Previously this only revealed the panel and waited for a button. If the
       customer instead clicked their cart, they left with the bare appointment
       line — no focus areas, no add-ons, nothing grouped — because the commit
       had never run. Now the reconcile fires as soon as the booking appears, so
       the cart is correct no matter where they go next. The reconcile is
       idempotent, so running it here and again on the button is harmless.
    --------------------------------------------------------------------- */
    var autoDone=false, autoRunning=false;
    /* Re-opened by the /cart/add interceptor when it mints a group for a NEW
       appointment. autoDone used to be a one-way latch, so the SECOND booking of a
       page session never got a reconcile pass and its focus areas and add-ons were
       never added. See the note on REARM for why this is safe now and was not
       before. */
    REARM = function(){ autoDone = false; };
    function autoCommit(){
      if(autoDone || autoRunning) return Promise.resolve();
      autoRunning=true;
      return commitCheckup('stay', null).then(function(){
        autoDone=true; autoRunning=false;
      }).catch(function(){ autoRunning=false; });
    }
    /* Gate on hasBooking, not pendingBooking. pendingBooking goes false as soon as the
       commit stamps the line, so on a reload after booking the panel never reappeared
       and the customer was left on EAB's confirmation with no Checkout button and no
       "Add another checkup" — EAB's own Checkout having been hidden as a duplicate.
       That dead end is what Will hit on step 3 of the MVP 7.0 review. */
    function check(){
      return getCart().then(function(c){
        /* Not hasBooking. On arrival for person 2 the cart already holds person 1's
           appointment; hasBooking said yes and this committed person 2's build with
           no date before they touched the calendar. It also revealed "Your
           appointment is held." to someone who had not booked. And a line the app
           touched but that carries no date is not an appointment either: revealing
           the panel over one, or auto-committing a build behind it, is how a
           dateless group gets built. (2026-08-11, 2026-08-24)
           pinnedDatedBooking: the booking this page's own add created, identified
           by the group minted onto that add rather than by "the first untagged
           line", which used to let one person's pass adopt another's appointment.
           (2026-08-27) */
        if(!pinnedDatedBooking(c)) return;
        reveal();
        /* Handed off already: show the box, reconcile nothing. autoDone is set so
           the poller idles — the interceptor's REARM re-opens it when a NEW
           appointment mints a fresh, unsealed group. (2026-09-18) */
        if(pinSealed()){ markSealed(); autoDone = true; return; }
        clearSealed();
        return autoCommit();
      }).catch(function(){});
    }

    /* Belt and braces: if the customer heads for the cart or checkout before the
       automatic pass has finished, hold the navigation just long enough to
       complete it. Capped so a wedged request can never trap them on the page. */
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href]');
      /* The `|| autoDone` that used to be here made this hold one-shot: a customer
         who booked a SECOND appointment and then clicked their cart left with that
         booking un-reconciled. autoCommit() resolves immediately when there is
         nothing to do, so dropping the guard costs one /cart.js read on a cart
         link and nothing else. (2026-08-27) */
      if(!a) return;
      var href = a.getAttribute('href') || '';
      /* Resolve before matching: a raw-string test misses absolute same-origin
         links (https://himedi.com/cart), which is exactly the header cart link
         if anyone ever swaps routes.cart_url for a full URL. */
      var path;
      try{ var u = new URL(href, window.location.origin);
           if(u.origin !== window.location.origin) return;
           path = u.pathname; }
      catch(_){ return; }
      if(!/^\/cart(\/|$|\?)|^\/checkout(\/|$|\?)/.test(path)) return;
      if(a.closest('.cf-app-slot')) return;            // handled by the interceptor below
      e.preventDefault();
      var go = function(){ window.location.href = href; };
      var bail = setTimeout(go, 4000);
      /* Re-read the cart before committing. With no appointment there is nothing to
         reconcile and the commit would CREATE a dateless cart instead — this click,
         on this page, is the path that produced #3104/#3105/#3110/#3113. When there
         is no booking the customer is simply sent to their cart untouched. */
      getCart().then(function(c){
        /* Heading for the cart without having booked must send them there
           untouched. Person 1's appointment is not a licence to commit person 2's
           build, and an untagged line is not a licence to commit anyone's. */
        if(!pinnedDatedBooking(c)){ clearTimeout(bail); go(); return; }
        return autoCommit().then(function(){ clearTimeout(bail); go(); });
      }).catch(function(){ clearTimeout(bail); go(); });
    }, true);

    // EAB fires no event we can listen for, so probe a few times after any
    // interaction with the widget rather than polling the cart continuously
    check();
    $$('.cf-app-slot').forEach(function(s){
      s.addEventListener('click', function(){ [700,1600,3000,5200].forEach(function(ms){ setTimeout(check, ms); }); });
    });

    /* The click probes above assume the customer's clicks reach .cf-app-slot. They do
       not when the widget mounts in an iframe — clicks inside it never bubble to the
       parent document — so on those renders the booking appeared and nothing noticed:
       no panel, no CTA, no reconcile. A slow poll covers that case without depending
       on the app's internals. It stops as soon as the group is committed, and gives up
       after ~3 minutes so an abandoned tab is not left polling. */
    var polls = 0;
    /* autoDone no longer STOPS the poller, it only skips a tick: a second booking
       re-opens the pass and the poller has to still be alive to notice. It issues
       no request while there is nothing to do, so the network cost is unchanged.
       (2026-08-27) */
    var poller = setInterval(function(){
      if(++polls > 150){ clearInterval(poller); return; }
      if(autoDone) return;
      check();
    }, 1200);

    // Intercept EAB's own Checkout in the capture phase. Left alone it would send
    // the customer to checkout with only the appointment line — no focus areas,
    // no add-ons, and nothing grouped.
    document.addEventListener('click', function(e){
      var t=e.target.closest && e.target.closest('a,button');
      if(!t || !t.closest('.cf-app-slot')) return;
      var txt=(t.textContent||'').trim().toLowerCase();
      if(/^check\s?out$/.test(txt) || /proceed to checkout/.test(txt)){
        e.preventDefault(); e.stopPropagation();
        commitCheckup('checkout', null);
      }
    }, true);

    if(panel){
      $$('[data-commit]',panel).forEach(function(b){
        b.addEventListener('click', function(){ commitCheckup(b.getAttribute('data-commit'), b); });
      });
    }
  }

  /* ---- keep only the calendar this build needs ----
     The section renders one EAB app block per calendar and an inline script drops
     the rest before the app boots. This is the safety net for the case where that
     script did not run (or the app injected late). */
  function pruneCalendars(){
    var slots=$$('.cf-app-slot[data-cal]');
    if(slots.length<2) return;
    var key=calendarKey(), keep=null, fallback=null;
    slots.forEach(function(s){
      var k=s.getAttribute('data-cal');
      if(k===key) keep=s;
      if(k==='baseline') fallback=s;
    });
    keep = keep || fallback || slots[0];
    slots.forEach(function(s){ if(s!==keep) s.parentNode && s.parentNode.removeChild(s); });
  }

  /* ---- test description sheet (focus-area "what's included" chips) ---- */
  function wireTestSheet(){
    var sheet=$('#cfSheet'); if(!sheet) return;
    var card=$('.cf-sheet-card',sheet), titleEl=$('#cfSheetTitle',sheet), descEl=$('#cfSheetDesc',sheet);
    var lastFocus=null;
    function open(name,desc){
      lastFocus=document.activeElement;
      titleEl.textContent=name; descEl.textContent=desc||'';
      sheet.classList.add('open'); sheet.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      var c=$('.cf-close',sheet); if(c) c.focus();
      document.addEventListener('keydown',onKey);
    }
    function close(){
      sheet.classList.remove('open'); sheet.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
      document.removeEventListener('keydown',onKey);
      if(lastFocus) lastFocus.focus();
    }
    function onKey(e){ if(e.key==='Escape') close(); }
    // event delegation so it covers all upgrade cards
    document.addEventListener('click',function(e){
      var chip=e.target.closest && e.target.closest('button.testchip');
      if(chip){ open(chip.getAttribute('data-name')||chip.textContent.trim(), chip.getAttribute('data-desc')); return; }
      if(e.target.closest && e.target.closest('.cf-sheet-scrim, .cf-close')) close();
    });
  }

  /* ---- init (feature-detect per page) ----
     2026-10-09 (speed): this file loads WITHOUT defer (himedi-checkup-chrome) and wires the page the
     moment it is parsed. DOMContentLoaded waits for every deferred script on the page, the booking
     app's 133 KB embedInit.js included, and on a slow phone that held every tap for seconds. Loaded
     without defer it is also always here before the files that read window.HimediFlow (add-ons A/B,
     summary edit) run. On the booking step the held-time box this reveals, the booked card
     himedi-summary-edit.js draws and the pinned bar from himedi-summary-next-step.js must change
     together, so those two load without defer as well. Everything below finds our own markup only. */
  var inited=false;
  function init(){
    if(inited) return; inited=true;
    pruneCalendars();
    wireUpgrades();
    wireAddons();
    renderSummary();
    wireBooking();
    wireConfirm();
    wireEabMode();
    wireTestSheet();
    wireQuizNotice();
    try{ reconcileStalePromos(); }catch(e){}
    // himedi-summary-edit.js mounts on this, so it always draws after this wiring however the two load.
    window.HimediFlow.ready=true;
    try{ document.dispatchEvent(new Event('himedi:flow-ready')); }catch(e){}
  }
  // Loaded without defer, this runs while the page is still loading: wire it when parsing ends.
  // Loaded deferred (an older copy of the chrome snippet), parsing has already ended: DOMContentLoaded.
  if(document.readyState==='loading'){
    document.addEventListener('readystatechange',function rs(){
      if(document.readyState==='loading') return;
      document.removeEventListener('readystatechange',rs); init();
    });
  } else if(document.readyState==='interactive'){
    document.addEventListener('DOMContentLoaded',init);
  } else init();

  /* The quiz writes its recommendation into this same state before handing over.
     Saying so on arrival stops the builder looking like it guessed. */
  function wireQuizNotice(){
    var n=$('#cfQuizNote'); if(!n) return;
    if(state.fromQuiz && $('.upcard')){
      n.hidden=false;
      state.fromQuiz=false; save(state); // only on the first visit after the quiz
    }
  }

  /* audit surface — used by the flow tests */
  window.HimediFlow = {
    calendarKey:calendarKey, makeGid:makeGid, legacyOrdinal:legacyOrdinal, seqKey:seqKey,
    mintGroupForAdd:mintGroupForAdd, provisionalRank:provisionalRank,
    setLineProps:setLineProps, canonicaliseLabels:canonicaliseLabels,
    canonicalGroups:canonicalGroups, rankOf:rankOf, groupFields:groupFields,
    pendingBooking:pendingBooking, hasBooking:hasBooking, isBookingLine:isBookingLine, eabMode:eabMode,
    pinnedDatedBooking:pinnedDatedBooking, isDatedBookingLine:isDatedBookingLine,
    lineDate:lineDate, groupDates:groupDates, isBaseVariant:isBaseVariant, wantFor:wantFor, diff:diff,
    legacyGroups:legacyGroups, CART_SCHEMA:CART_SCHEMA, VKEY:VKEY, GKEY:GKEY, GLABEL:GLABEL, SKEY:SKEY,
    buildItems:buildItems, desiredVariants:desiredVariants, total:total,
    gid:function(){ return COMMIT_GID; }, seq:function(){ return COMMIT_SEQ; },
    sealed:function(){ return SEALED_GID; }, pinSealed:pinSealed, buildHash:buildHash,
    state:function(){ return state; }, setState:function(s){ state=s; save(state); },
    /* 2026-09-25: read by himedi-summary-edit.js (the edit card on the summary page), which reuses
       the add-on page's own row wiring and coverage rule instead of copying them. Read-only. */
    wireAddons:wireAddons, isCovered:isCovered, upgradeAvailable:upgradeAvailable, baseKey:baseKey,
    catalog:function(){ return { BASES:BASES, UPGRADES:UPGRADES, ADDONS:ADDONS, ADDONS_BY_BASE:ADDONS_BY_BASE, COMBO_VARIANTS:COMBO_VARIANTS, WBMRI_COMBO_VARIANT:WBMRI_COMBO_VARIANT, WBMRI_STD_TO_PROMO:WBMRI_STD_TO_PROMO, WBMRI_PROMO_TO_STD:WBMRI_PROMO_TO_STD }; },
    // 2026-09-28 ended promo stale-cart fix -- exposed so it can be called directly in a test
    // without waiting for DOMContentLoaded, and so its result can be awaited.
    reconcileStalePromos:reconcileStalePromos
  };
})();
